/* ══ GENERAT din colecția `kal-fire` din Shopify. NU EDITA DE MÂNĂ. ══════════
   Se regenerează cu `python3 _din-shopify.py`. Culorile, pozele, prețurile și
   variant id-urile vin din produse, deci un preț schimbat în admin ajunge aici
   printr-o rulare, nu prin editare. Specificațiile fizice ale firelor (metraj,
   gramaj, tensiune, compoziție) NU sunt pe produs, deci rămân în `data.js`.
   ══════════════════════════════════════════════════════════════════════════ */
const CULORI = {
 "kal-01-petiteknit-double-sunday": [
  {
   "cod": "1012",
   "nume": "Whipped Cream",
   "eticheta": "1012 Whipped Cream",
   "price": 47.0,
   "variantId": "53537506001162",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11141012_whipped-cream_300dpi_noste.jpg?v=1787215554&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11141012_whipped-cream_300dpi_noste.jpg?v=1787215554&width=64",
   "hex": "#F2EFE8"
  },
  {
   "cod": "2013",
   "nume": "Pineapple",
   "eticheta": "2013 Pineapple",
   "price": 47.0,
   "variantId": "53537506033930",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11142013_pineapple_300dpi_noste_1.jpg?v=1787215556&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11142013_pineapple_300dpi_noste_1.jpg?v=1787215556&width=64",
   "hex": "#EFCC74",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11142013_pineapple_300dpi_noste_1.jpg?v=1787215556&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "2511",
   "nume": "Almond",
   "eticheta": "2511 Almond",
   "price": 47.0,
   "variantId": "53537506066698",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11142511_almond_300dpi_noste.jpg?v=1787215556&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11142511_almond_300dpi_noste.jpg?v=1787215556&width=64",
   "hex": "#E1D0BA",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11142511_almond_300dpi_noste.jpg?v=1787215556&width=96",
   "poz": "88% 50%"
  },
  {
   "cod": "2542",
   "nume": "Camel",
   "eticheta": "2542 Camel",
   "price": 47.0,
   "variantId": "53537506099466",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11142542_camel_300dpi_noste.jpg?v=1787215555&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11142542_camel_300dpi_noste.jpg?v=1787215555&width=64",
   "hex": "#AE8F70",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11142542_camel_300dpi_noste.jpg?v=1787215555&width=96",
   "poz": "88% 50%"
  },
  {
   "cod": "3821",
   "nume": "Cardamom",
   "eticheta": "3821 Cardamom",
   "price": 47.0,
   "variantId": "53537506132234",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11143821_kardemomme_300dpi_noste.jpg?v=1787215554&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11143821_kardemomme_300dpi_noste.jpg?v=1787215554&width=64",
   "hex": "#C6B5A8",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11143821_kardemomme_300dpi_noste.jpg?v=1787215554&width=96",
   "poz": "88% 50%"
  },
  {
   "cod": "4008",
   "nume": "Poppy",
   "eticheta": "4008 Poppy",
   "price": 47.0,
   "variantId": "53537506165002",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11144008_poppy_300dpi_noste_1.jpg?v=1787215555&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11144008_poppy_300dpi_noste_1.jpg?v=1787215555&width=64",
   "hex": "#E6313B",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11144008_poppy_300dpi_noste_1.jpg?v=1787215555&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "4604",
   "nume": "Flamingo",
   "eticheta": "4604 Flamingo",
   "price": 47.0,
   "variantId": "53537506197770",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11144604_flamingo_300dpi_noste_1.jpg?v=1787215556&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11144604_flamingo_300dpi_noste_1.jpg?v=1787215556&width=64",
   "hex": "#EA7EAA",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11144604_flamingo_300dpi_noste_1.jpg?v=1787215556&width=96",
   "poz": "88% 50%"
  },
  {
   "cod": "5012",
   "nume": "Perfect Purple",
   "eticheta": "5012 Perfect Purple",
   "price": 47.0,
   "variantId": "53537506230538",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11145012_perfect-purple_300dpi_noste_1.jpg?v=1787215556&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11145012_perfect-purple_300dpi_noste_1.jpg?v=1787215556&width=64",
   "hex": "#E1DDDE"
  },
  {
   "cod": "5591",
   "nume": "Night Sky",
   "eticheta": "5591 Night Sky",
   "price": 47.0,
   "variantId": "53537506263306",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11145591_night-sky_300dpi_noste_1.jpg?v=1787215556&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11145591_night-sky_300dpi_noste_1.jpg?v=1787215556&width=64",
   "hex": "#272735",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11145591_night-sky_300dpi_noste_1.jpg?v=1787215556&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "6043",
   "nume": "Baby Blue Eyes",
   "eticheta": "6043 Baby Blue Eyes",
   "price": 47.0,
   "variantId": "53537506296074",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11146043_baby-blue-eyes_300dpi_noste_1.jpg?v=1787215556&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11146043_baby-blue-eyes_300dpi_noste_1.jpg?v=1787215556&width=64",
   "hex": "#708BAA",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11146043_baby-blue-eyes_300dpi_noste_1.jpg?v=1787215556&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "6046",
   "nume": "Electric Blue",
   "eticheta": "6046 Electric Blue",
   "price": 47.0,
   "variantId": "53537506328842",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11146046_electric-blue_300dpi_noste.jpg?v=1787215556&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11146046_electric-blue_300dpi_noste.jpg?v=1787215556&width=64",
   "hex": "#054C93",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11146046_electric-blue_300dpi_noste.jpg?v=1787215556&width=96",
   "poz": "88% 50%"
  },
  {
   "cod": "6050",
   "nume": "Above The Clouds",
   "eticheta": "6050 Above The Clouds",
   "price": 47.0,
   "variantId": "53537506361610",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11146050_above-the-clouds_300dpi_noste_1.jpg?v=1787215556&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11146050_above-the-clouds_300dpi_noste_1.jpg?v=1787215556&width=64",
   "hex": "#83919B",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11146050_above-the-clouds_300dpi_noste_1.jpg?v=1787215556&width=96",
   "poz": "88% 50%"
  },
  {
   "cod": "7723",
   "nume": "Mint",
   "eticheta": "7723 Mint",
   "price": 47.0,
   "variantId": "53537506394378",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11147723_mint_300dpi_noste_1.jpg?v=1787215556&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11147723_mint_300dpi_noste_1.jpg?v=1787215556&width=64",
   "hex": "#8AC8B4",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11147723_mint_300dpi_noste_1.jpg?v=1787215556&width=96",
   "poz": "88% 50%"
  },
  {
   "cod": "8236",
   "nume": "Statement Green",
   "eticheta": "8236 Statement Green",
   "price": 47.0,
   "variantId": "53537506427146",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11148236_statement-green_300dpi_noste.jpg?v=1787215556&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11148236_statement-green_300dpi_noste.jpg?v=1787215556&width=64",
   "hex": "#119155",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11148236_statement-green_300dpi_noste.jpg?v=1787215556&width=96",
   "poz": "88% 50%"
  },
  {
   "cod": "9533",
   "nume": "Green Tea",
   "eticheta": "9533 Green Tea",
   "price": 47.0,
   "variantId": "53537506459914",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11149533_green-tea_300dpi_noste_1.jpg?v=1787215555&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11149533_green-tea_300dpi_noste_1.jpg?v=1787215555&width=64",
   "hex": "#9B9F6A",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11149533_green-tea_300dpi_noste_1.jpg?v=1787215555&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "9564",
   "nume": "Matcha",
   "eticheta": "9564 Matcha",
   "price": 47.0,
   "variantId": "53537506492682",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11149564_matcha_300dpi_noste_1.jpg?v=1787215556&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11149564_matcha_300dpi_noste_1.jpg?v=1787215556&width=64",
   "hex": "#737637",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11149564_matcha_300dpi_noste_1.jpg?v=1787215556&width=96",
   "poz": "88% 50%"
  }
 ],
 "kal-01-double-sunday": [
  {
   "cod": "1001",
   "nume": "True White",
   "eticheta": "1001 True White",
   "price": 47.0,
   "variantId": "53529378619658",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11151001_hvit_300dpi_noste_1_520c0add-e8c6-46e2-a0eb-87de8b5bfeaf.jpg?v=1787043747&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11151001_hvit_300dpi_noste_1_520c0add-e8c6-46e2-a0eb-87de8b5bfeaf.jpg?v=1787043747&width=64",
   "hex": "#F6F4F0"
  },
  {
   "cod": "1015",
   "nume": "Morning Mist",
   "eticheta": "1015 Morning Mist",
   "price": 47.0,
   "variantId": "53529378652426",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11151015_kitt_300dpi_noste_1.jpg?v=1787043747&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11151015_kitt_300dpi_noste_1.jpg?v=1787043747&width=64",
   "hex": "#F1F1F0"
  },
  {
   "cod": "1042",
   "nume": "Grey Melange",
   "eticheta": "1042 Grey Melange",
   "price": 47.0,
   "variantId": "53529378685194",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11151042_gramelert_300dpi_noste_1.jpg?v=1787043747&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11151042_gramelert_300dpi_noste_1.jpg?v=1787043747&width=64",
   "hex": "#A1A09B",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11151042_gramelert_300dpi_noste_1.jpg?v=1787043747&width=96",
   "poz": "88% 50%"
  },
  {
   "cod": "1099",
   "nume": "Black",
   "eticheta": "1099 Black",
   "price": 47.0,
   "variantId": "53529378717962",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11151099_svart_300dpi_noste_1.jpg?v=1787043748&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11151099_svart_300dpi_noste_1.jpg?v=1787043748&width=64",
   "hex": "#19181C",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11151099_svart_300dpi_noste_1.jpg?v=1787043748&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "2321",
   "nume": "Marzipan",
   "eticheta": "2321 Marzipan",
   "price": 47.0,
   "variantId": "53529378750730",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11152321_marsipan_300dpi_noste_2.jpg?v=1787043748&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11152321_marsipan_300dpi_noste_2.jpg?v=1787043748&width=64",
   "hex": "#D1BFB2",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11152321_marsipan_300dpi_noste_2.jpg?v=1787043748&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "2351",
   "nume": "Taupe",
   "eticheta": "2351 Taupe",
   "price": 47.0,
   "variantId": "53529378783498",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11152351_taupe_300dpi_noste_1.jpg?v=1787043748&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11152351_taupe_300dpi_noste_1.jpg?v=1787043748&width=64",
   "hex": "#A2938A",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11152351_taupe_300dpi_noste_1.jpg?v=1787043748&width=96",
   "poz": "88% 50%"
  },
  {
   "cod": "2573",
   "nume": "Monk's Robe",
   "eticheta": "2573 Monk's Robe",
   "price": 47.0,
   "variantId": "53529378816266",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11152573_monks-robe_300dpi_noste.jpg?v=1787043748&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11152573_monks-robe_300dpi_noste.jpg?v=1787043748&width=64",
   "hex": "#835124",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11152573_monks-robe_300dpi_noste.jpg?v=1787043748&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "2650",
   "nume": "Beige Melange",
   "eticheta": "2650 Beige Melange",
   "price": 47.0,
   "variantId": "53529378849034",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11152650_beigemelert_300dpi_noste_1.jpg?v=1787043747&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11152650_beigemelert_300dpi_noste_1.jpg?v=1787043747&width=64",
   "hex": "#CAB2A7",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11152650_beigemelert_300dpi_noste_1.jpg?v=1787043747&width=96",
   "poz": "88% 50%"
  },
  {
   "cod": "2745",
   "nume": "Cognac",
   "eticheta": "2745 Cognac",
   "price": 47.0,
   "variantId": "53529378881802",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11152745_cognac_300dpi_noste_1.jpg?v=1787043749&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11152745_cognac_300dpi_noste_1.jpg?v=1787043749&width=64",
   "hex": "#B75C26",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11152745_cognac_300dpi_noste_1.jpg?v=1787043749&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "3052",
   "nume": "Pecan Brown",
   "eticheta": "3052 Pecan Brown",
   "price": 47.0,
   "variantId": "53529378914570",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11153052_pecan-brown_300dpi_noste.jpg?v=1787043749&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11153052_pecan-brown_300dpi_noste.jpg?v=1787043749&width=64",
   "hex": "#93634C",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11153052_pecan-brown_300dpi_noste.jpg?v=1787043749&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "3161",
   "nume": "Acorn",
   "eticheta": "3161 Acorn",
   "price": 47.0,
   "variantId": "53529378947338",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11153161_eikenott_300dpi_noste_1.jpg?v=1787043749&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11153161_eikenott_300dpi_noste_1.jpg?v=1787043749&width=64",
   "hex": "#735953",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11153161_eikenott_300dpi_noste_1.jpg?v=1787043749&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "3509",
   "nume": "Ballet Tutu",
   "eticheta": "3509 Ballet Tutu",
   "price": 47.0,
   "variantId": "53529378980106",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11153509_ballet-tutu_300dpi_noste_1.jpg?v=1787043749&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11153509_ballet-tutu_300dpi_noste_1.jpg?v=1787043749&width=64",
   "hex": "#EFCFC6",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11153509_ballet-tutu_300dpi_noste_1.jpg?v=1787043749&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "3800",
   "nume": "Bristol Black",
   "eticheta": "3800 Bristol Black",
   "price": 47.0,
   "variantId": "53529379012874",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11153800_bristol-black_300dpi_noste_1.jpg?v=1787043749&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11153800_bristol-black_300dpi_noste_1.jpg?v=1787043749&width=64",
   "hex": "#332D2F",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11153800_bristol-black_300dpi_noste_1.jpg?v=1787043749&width=96",
   "poz": "88% 50%"
  },
  {
   "cod": "3880",
   "nume": "Dark Chocolate",
   "eticheta": "3880 Dark Chocolate",
   "price": 47.0,
   "variantId": "53529379045642",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11153880_mork-sjokolade_300dpi_noste_1.jpg?v=1787043749&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11153880_mork-sjokolade_300dpi_noste_1.jpg?v=1787043749&width=64",
   "hex": "#50423F",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11153880_mork-sjokolade_300dpi_noste_1.jpg?v=1787043749&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "4018",
   "nume": "Scarlet Red",
   "eticheta": "4018 Scarlet Red",
   "price": 47.0,
   "variantId": "53529379078410",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154018_scarlet-red_300dpi_noste_1.jpg?v=1787043749&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154018_scarlet-red_300dpi_noste_1.jpg?v=1787043749&width=64",
   "hex": "#CC2C30",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154018_scarlet-red_300dpi_noste_1.jpg?v=1787043749&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "4219",
   "nume": "True Red",
   "eticheta": "4219 True Red",
   "price": 47.0,
   "variantId": "53529379111178",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154219_rod_300dpi_noste_1.jpg?v=1787043751&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154219_rod_300dpi_noste_1.jpg?v=1787043751&width=64",
   "hex": "#B40C23",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154219_rod_300dpi_noste_1.jpg?v=1787043751&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "4236",
   "nume": "Deep Red",
   "eticheta": "4236 Deep Red",
   "price": 47.0,
   "variantId": "53529379143946",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154236_dyp-rod_300dpi_noste-2.jpg?v=1787043751&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154236_dyp-rod_300dpi_noste-2.jpg?v=1787043751&width=64",
   "hex": "#841626",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154236_dyp-rod_300dpi_noste-2.jpg?v=1787043751&width=96",
   "poz": "88% 50%"
  },
  {
   "cod": "4353",
   "nume": "Rustic Rose",
   "eticheta": "4353 Rustic Rose",
   "price": 47.0,
   "variantId": "53529379176714",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154353_rustic_rose_300dpi_noste.jpg?v=1787043751&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154353_rustic_rose_300dpi_noste.jpg?v=1787043751&width=64",
   "hex": "#7A2F3D",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154353_rustic_rose_300dpi_noste.jpg?v=1787043751&width=96",
   "poz": "88% 50%"
  },
  {
   "cod": "4372",
   "nume": "Burgundy",
   "eticheta": "4372 Burgundy",
   "price": 47.0,
   "variantId": "53529379209482",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154372_dyp-burgunder_300dpi_noste_1.jpg?v=1787043751&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154372_dyp-burgunder_300dpi_noste_1.jpg?v=1787043751&width=64",
   "hex": "#56252F",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154372_dyp-burgunder_300dpi_noste_1.jpg?v=1787043751&width=96",
   "poz": "88% 50%"
  },
  {
   "cod": "4511",
   "nume": "Ballet Rose",
   "eticheta": "4511 Ballet Rose",
   "price": 47.0,
   "variantId": "53529379242250",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154511_lilac-snow_300dpi_noste.jpg?v=1787043751&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154511_lilac-snow_300dpi_noste.jpg?v=1787043751&width=64",
   "hex": "#ECC6CF",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154511_lilac-snow_300dpi_noste.jpg?v=1787043751&width=96",
   "poz": "88% 50%"
  },
  {
   "cod": "4518",
   "nume": "Hot Pink",
   "eticheta": "4518 Hot Pink",
   "price": 47.0,
   "variantId": "53529379275018",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154518_hot-pink_300dpi_noste.jpg?v=1787043751&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154518_hot-pink_300dpi_noste.jpg?v=1787043751&width=64",
   "hex": "#DD3471",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154518_hot-pink_300dpi_noste.jpg?v=1787043751&width=96",
   "poz": "88% 50%"
  },
  {
   "cod": "4626",
   "nume": "Shocking Pink",
   "eticheta": "4626 Shocking Pink",
   "price": 47.0,
   "variantId": "53529379307786",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154626_shocking-pink_300dpi_noste_1.jpg?v=1787043751&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154626_shocking-pink_300dpi_noste_1.jpg?v=1787043751&width=64",
   "hex": "#D780AC",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154626_shocking-pink_300dpi_noste_1.jpg?v=1787043751&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "4672",
   "nume": "Blackberry Juice",
   "eticheta": "4672 Blackberry Juice",
   "price": 47.0,
   "variantId": "53529379340554",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154672_bjornebaersaft_300dpi_noste_1.jpg?v=1787043750&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154672_bjornebaersaft_300dpi_noste_1.jpg?v=1787043750&width=64",
   "hex": "#562F4F",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11154672_bjornebaersaft_300dpi_noste_1.jpg?v=1787043750&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "5045",
   "nume": "Plum",
   "eticheta": "5045 Plum",
   "price": 47.0,
   "variantId": "53529379373322",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11155045_plum_300dpi_noste.jpg?v=1787043752&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11155045_plum_300dpi_noste.jpg?v=1787043752&width=64",
   "hex": "#793882",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11155045_plum_300dpi_noste.jpg?v=1787043752&width=96",
   "poz": "88% 50%"
  },
  {
   "cod": "5223",
   "nume": "Lavender",
   "eticheta": "5223 Lavender",
   "price": 47.0,
   "variantId": "53529379406090",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11155223_lavender_300dpi_noste.jpg?v=1787043752&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11155223_lavender_300dpi_noste.jpg?v=1787043752&width=64",
   "hex": "#A89CB1"
  },
  {
   "cod": "5811",
   "nume": "Arctic Ice",
   "eticheta": "5811 Arctic Ice",
   "price": 47.0,
   "variantId": "53529379438858",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11155811_arctic-ice_300dpi_noste_1.jpg?v=1787043752&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11155811_arctic-ice_300dpi_noste_1.jpg?v=1787043752&width=64",
   "hex": "#F1F1F0"
  },
  {
   "cod": "5812",
   "nume": "Brunnera Blue",
   "eticheta": "5812 Brunnera Blue",
   "price": 47.0,
   "variantId": "53529379471626",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11155812_brunnera-blue_300dpi_noste.jpg?v=1787043752&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11155812_brunnera-blue_300dpi_noste.jpg?v=1787043752&width=64",
   "hex": "#A6BBDC",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11155812_brunnera-blue_300dpi_noste.jpg?v=1787043752&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "5845",
   "nume": "Dazzling Blue",
   "eticheta": "5845 Dazzling Blue",
   "price": 47.0,
   "variantId": "53529379504394",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11155845_dazzling-blue_300dpi_noste_04a87793-60df-4aac-a059-f653632804d2.jpg?v=1787043752&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11155845_dazzling-blue_300dpi_noste_04a87793-60df-4aac-a059-f653632804d2.jpg?v=1787043752&width=64",
   "hex": "#244B9D",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11155845_dazzling-blue_300dpi_noste_04a87793-60df-4aac-a059-f653632804d2.jpg?v=1787043752&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "5846",
   "nume": "True Blue",
   "eticheta": "5846 True Blue",
   "price": 47.0,
   "variantId": "53529379537162",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11155846_bla_300dpi_noste_1.jpg?v=1787043752&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11155846_bla_300dpi_noste_1.jpg?v=1787043752&width=64",
   "hex": "#284374",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11155846_bla_300dpi_noste_1.jpg?v=1787043752&width=96",
   "poz": "88% 50%"
  },
  {
   "cod": "6032",
   "nume": "Blue Hydrangea",
   "eticheta": "6032 Blue Hydrangea",
   "price": 47.0,
   "variantId": "53529379569930",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11156032_bla-hortensia_300dpi_noste_1.jpg?v=1787043752&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11156032_bla-hortensia_300dpi_noste_1.jpg?v=1787043752&width=64",
   "hex": "#819AB4",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11156032_bla-hortensia_300dpi_noste_1.jpg?v=1787043752&width=96",
   "poz": "88% 50%"
  },
  {
   "cod": "6044",
   "nume": "Regatta Blue",
   "eticheta": "6044 Regatta Blue",
   "price": 47.0,
   "variantId": "53529379602698",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11156044_regatta-bla_300dpi_noste_1.jpg?v=1787043752&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11156044_regatta-bla_300dpi_noste_1.jpg?v=1787043752&width=64",
   "hex": "#6187BB",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11156044_regatta-bla_300dpi_noste_1.jpg?v=1787043752&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "6051",
   "nume": "Linen Blue",
   "eticheta": "6051 Linen Blue",
   "price": 47.0,
   "variantId": "53529379635466",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11156051_kveldshimmel_300dpi_noste_1.jpg?v=1787043753&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11156051_kveldshimmel_300dpi_noste_1.jpg?v=1787043753&width=64",
   "hex": "#71828B",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11156051_kveldshimmel_300dpi_noste_1.jpg?v=1787043753&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "6580",
   "nume": "Midnight Blue",
   "eticheta": "6580 Midnight Blue",
   "price": 47.0,
   "variantId": "53529379668234",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11156580_bla-natt_300dpi_noste_1.jpg?v=1787043753&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11156580_bla-natt_300dpi_noste_1.jpg?v=1787043753&width=64",
   "hex": "#333946",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11156580_bla-natt_300dpi_noste_1.jpg?v=1787043753&width=96",
   "poz": "88% 50%"
  },
  {
   "cod": "7526",
   "nume": "Spectra Green",
   "eticheta": "7526 Spectra Green",
   "price": 47.0,
   "variantId": "53529379701002",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11157526_spectra-green_300dpi_noste.jpg?v=1787043754&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11157526_spectra-green_300dpi_noste.jpg?v=1787043754&width=64",
   "hex": "#05B5A8",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11157526_spectra-green_300dpi_noste.jpg?v=1787043754&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "7772",
   "nume": "Rain Forest",
   "eticheta": "7772 Rain Forest",
   "price": 47.0,
   "variantId": "53529379733770",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11157772_rainforest_300dpi_noste.jpg?v=1787043754&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11157772_rainforest_300dpi_noste.jpg?v=1787043754&width=64",
   "hex": "#265144",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11157772_rainforest_300dpi_noste.jpg?v=1787043754&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "7911",
   "nume": "Mint Green",
   "eticheta": "7911 Mint Green",
   "price": 47.0,
   "variantId": "53529379766538",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11157911_mint-green_300dpi_noste_c04977ab-a1bc-453a-9c14-9daf7282a06c.jpg?v=1787043753&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11157911_mint-green_300dpi_noste_c04977ab-a1bc-453a-9c14-9daf7282a06c.jpg?v=1787043753&width=64",
   "hex": "#DCECDB"
  },
  {
   "cod": "8073",
   "nume": "Elm Green",
   "eticheta": "8073 Elm Green",
   "price": 47.0,
   "variantId": "53529379799306",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11158073_elm-green_300dpi_noste.jpg?v=1787043754&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11158073_elm-green_300dpi_noste.jpg?v=1787043754&width=64",
   "hex": "#3F6149",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11158073_elm-green_300dpi_noste.jpg?v=1787043754&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "8082",
   "nume": "Forest Green",
   "eticheta": "8082 Forest Green",
   "price": 47.0,
   "variantId": "53529379832074",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11158082_skoggronn_300dpi_noste_1.jpg?v=1787043753&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11158082_skoggronn_300dpi_noste_1.jpg?v=1787043753&width=64",
   "hex": "#2A3C2E",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11158082_skoggronn_300dpi_noste_1.jpg?v=1787043753&width=96",
   "poz": "88% 50%"
  },
  {
   "cod": "8521",
   "nume": "Dusty Light Green",
   "eticheta": "8521 Dusty Light Green",
   "price": 47.0,
   "variantId": "53529379864842",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11158521_stovet-lys-gronn_300dpi_noste_1.jpg?v=1787043753&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11158521_stovet-lys-gronn_300dpi_noste_1.jpg?v=1787043753&width=64",
   "hex": "#909485",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11158521_stovet-lys-gronn_300dpi_noste_1.jpg?v=1787043753&width=96",
   "poz": "88% 50%"
  },
  {
   "cod": "8733",
   "nume": "Spring Green",
   "eticheta": "8733 Spring Green",
   "price": 47.0,
   "variantId": "53529379897610",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11158733_spring-green_300dpi_noste_1.jpg?v=1787043755&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11158733_spring-green_300dpi_noste_1.jpg?v=1787043755&width=64",
   "hex": "#A1BB8A",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11158733_spring-green_300dpi_noste_1.jpg?v=1787043755&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "9080",
   "nume": "Urban Chic",
   "eticheta": "9080 Urban Chic",
   "price": 47.0,
   "variantId": "53529379930378",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11159080_urban-chic_300dpi_noste_1.jpg?v=1787043755&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11159080_urban-chic_300dpi_noste_1.jpg?v=1787043755&width=64",
   "hex": "#404C47",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11159080_urban-chic_300dpi_noste_1.jpg?v=1787043755&width=96",
   "poz": "0% 50%"
  }
 ],
 "kal-01-como": [
  {
   "cod": "00",
   "nume": "Wool White",
   "eticheta": "00 Wool White",
   "price": 52.0,
   "variantId": "53525438693642",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_00_Natur_Wool-White.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_00_Natur_Wool-White.jpg?v=1786971438&width=64",
   "hex": "#BEB1A0",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_00_Natur_Wool-White.jpg?v=1786971438&width=96",
   "poz": "38% 88%"
  },
  {
   "cod": "01",
   "nume": "Black",
   "eticheta": "01 Black",
   "price": 52.0,
   "variantId": "53525438726410",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_01_Schwarz_Black.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_01_Schwarz_Black.jpg?v=1786971438&width=64",
   "hex": "#201D1F",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_01_Schwarz_Black.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "03M",
   "nume": "Silk Grey",
   "eticheta": "03M Silk Grey",
   "price": 52.0,
   "variantId": "53525438759178",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_03M_Seidengrau_Silk-Grey.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_03M_Seidengrau_Silk-Grey.jpg?v=1786971438&width=64",
   "hex": "#9E9184",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_03M_Seidengrau_Silk-Grey.jpg?v=1786971438&width=96",
   "poz": "38% 88%"
  },
  {
   "cod": "04M",
   "nume": "Anthracite",
   "eticheta": "04M Anthracite",
   "price": 52.0,
   "variantId": "53525438791946",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_04M_Anthrazit_Anthracite.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_04M_Anthrazit_Anthracite.jpg?v=1786971438&width=64",
   "hex": "#39353B",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_04M_Anthrazit_Anthracite.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "05M",
   "nume": "Silver Grey",
   "eticheta": "05M Silver Grey",
   "price": 52.0,
   "variantId": "53525438824714",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_05M_Silbergrau_Silver-Grey.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_05M_Silbergrau_Silver-Grey.jpg?v=1786971438&width=64",
   "hex": "#7B7777",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_05M_Silbergrau_Silver-Grey.jpg?v=1786971438&width=96",
   "poz": "38% 75%"
  },
  {
   "cod": "06",
   "nume": "Chestnut Brown",
   "eticheta": "06 Chestnut Brown",
   "price": 52.0,
   "variantId": "53525438857482",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_06_Maronenbraun_Chestnut-Brown.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_06_Maronenbraun_Chestnut-Brown.jpg?v=1786971438&width=64",
   "hex": "#5F4647",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_06_Maronenbraun_Chestnut-Brown.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "07",
   "nume": "Khaki",
   "eticheta": "07 Khaki",
   "price": 52.0,
   "variantId": "53525438890250",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_07_Khaki.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_07_Khaki.jpg?v=1786971438&width=64",
   "hex": "#47371F",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_07_Khaki.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "08",
   "nume": "Curry",
   "eticheta": "08 Curry",
   "price": 52.0,
   "variantId": "53525438923018",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_08_Curry.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_08_Curry.jpg?v=1786971438&width=64",
   "hex": "#D49F33",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_08_Curry.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "10",
   "nume": "Royal",
   "eticheta": "10 Royal",
   "price": 52.0,
   "variantId": "53525438955786",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_10_Koenigsblau_Royal.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_10_Koenigsblau_Royal.jpg?v=1786971438&width=64",
   "hex": "#0B64BE",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_10_Koenigsblau_Royal.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "11",
   "nume": "Navy",
   "eticheta": "11 Navy",
   "price": 52.0,
   "variantId": "53525438988554",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_11_Marineblau_Navy.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_11_Marineblau_Navy.jpg?v=1786971438&width=64",
   "hex": "#243050",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_11_Marineblau_Navy.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "12M",
   "nume": "Jeans",
   "eticheta": "12M Jeans",
   "price": 52.0,
   "variantId": "53525439021322",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_12M_Jeans.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_12M_Jeans.jpg?v=1786971438&width=64",
   "hex": "#5F98CD",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_12M_Jeans.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "15",
   "nume": "Chili",
   "eticheta": "15 Chili",
   "price": 52.0,
   "variantId": "53525439054090",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_15_Chili.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_15_Chili.jpg?v=1786971438&width=64",
   "hex": "#BC2434",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_15_Chili.jpg?v=1786971438&width=96",
   "poz": "38% 12%"
  },
  {
   "cod": "16",
   "nume": "Bordeaux",
   "eticheta": "16 Bordeaux",
   "price": 52.0,
   "variantId": "53525439086858",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_16_Bordeaux.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_16_Bordeaux.jpg?v=1786971438&width=64",
   "hex": "#431A20",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_16_Bordeaux.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "24",
   "nume": "Petrol",
   "eticheta": "24 Petrol",
   "price": 52.0,
   "variantId": "53525439119626",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_24_Petrol.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_24_Petrol.jpg?v=1786971438&width=64",
   "hex": "#0C4E66",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_24_Petrol.jpg?v=1786971438&width=96",
   "poz": "38% 12%"
  },
  {
   "cod": "25",
   "nume": "Copper",
   "eticheta": "25 Copper",
   "price": 52.0,
   "variantId": "53525439152394",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_25_Kupfer_Copper.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_25_Kupfer_Copper.jpg?v=1786971438&width=64",
   "hex": "#A8492C",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_25_Kupfer_Copper.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "26",
   "nume": "Cream",
   "eticheta": "26 Cream",
   "price": 52.0,
   "variantId": "53525439185162",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_26_Creme_Cream.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_26_Creme_Cream.jpg?v=1786971438&width=64",
   "hex": "#B69F8D",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_26_Creme_Cream.jpg?v=1786971438&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "28M",
   "nume": "Slate Grey",
   "eticheta": "28M Slate Grey",
   "price": 52.0,
   "variantId": "53525439217930",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_28M_Schiefergrau_Slate-Grey.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_28M_Schiefergrau_Slate-Grey.jpg?v=1786971438&width=64",
   "hex": "#615C5F",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_28M_Schiefergrau_Slate-Grey.jpg?v=1786971438&width=96",
   "poz": "25% 50%"
  },
  {
   "cod": "29",
   "nume": "Chocolate",
   "eticheta": "29 Chocolate",
   "price": 52.0,
   "variantId": "53525439250698",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/lamana-como-29-schokolade-chocolate.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/lamana-como-29-schokolade-chocolate.jpg?v=1786971438&width=64",
   "hex": "#4B2F23",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/lamana-como-29-schokolade-chocolate.jpg?v=1786971438&width=96",
   "poz": "38% 25%"
  },
  {
   "cod": "30",
   "nume": "Caramel",
   "eticheta": "30 Caramel",
   "price": 52.0,
   "variantId": "53525439283466",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_30_Karamell_Caramel.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_30_Karamell_Caramel.jpg?v=1786971438&width=64",
   "hex": "#B88F73",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_30_Karamell_Caramel.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "31",
   "nume": "Plum",
   "eticheta": "31 Plum",
   "price": 52.0,
   "variantId": "53525439316234",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_31_Pflaume_Plum.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_31_Pflaume_Plum.jpg?v=1786971438&width=64",
   "hex": "#826C9A",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_31_Pflaume_Plum.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "32",
   "nume": "Lilac",
   "eticheta": "32 Lilac",
   "price": 52.0,
   "variantId": "53525439349002",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_32_Flieder_Lilac.jpg?v=1786971439&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_32_Flieder_Lilac.jpg?v=1786971439&width=64",
   "hex": "#7F4D71",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_32_Flieder_Lilac.jpg?v=1786971439&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "33",
   "nume": "Carmine",
   "eticheta": "33 Carmine",
   "price": 52.0,
   "variantId": "53525439381770",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_33_Karmin_Carmine.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_33_Karmin_Carmine.jpg?v=1786971438&width=64",
   "hex": "#A41B28",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_33_Karmin_Carmine.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "34",
   "nume": "Pine",
   "eticheta": "34 Pine",
   "price": 52.0,
   "variantId": "53525439414538",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_34_Pinie_Pine.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_34_Pinie_Pine.jpg?v=1786971438&width=64",
   "hex": "#3B3821",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_34_Pinie_Pine.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "36",
   "nume": "Pigeon Blue",
   "eticheta": "36 Pigeon Blue",
   "price": 52.0,
   "variantId": "53525439447306",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_36_Taubenblau_Pigeon-Blue.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_36_Taubenblau_Pigeon-Blue.jpg?v=1786971438&width=64",
   "hex": "#7F9AA6",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_36_Taubenblau_Pigeon-Blue.jpg?v=1786971438&width=96",
   "poz": "50% 88%"
  },
  {
   "cod": "37",
   "nume": "Pearl Grey",
   "eticheta": "37 Pearl Grey",
   "price": 52.0,
   "variantId": "53525439480074",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_37_Perlgrau_Pearl-Grey.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_37_Perlgrau_Pearl-Grey.jpg?v=1786971438&width=64",
   "hex": "#847879",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_37_Perlgrau_Pearl-Grey.jpg?v=1786971438&width=96",
   "poz": "38% 88%"
  },
  {
   "cod": "38",
   "nume": "Linden Green",
   "eticheta": "38 Linden Green",
   "price": 52.0,
   "variantId": "53525439512842",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_38_Lind_Linden-Green.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_38_Lind_Linden-Green.jpg?v=1786971438&width=64",
   "hex": "#88A39C",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_38_Lind_Linden-Green.jpg?v=1786971438&width=96",
   "poz": "50% 88%"
  },
  {
   "cod": "40",
   "nume": "Antique Pink",
   "eticheta": "40 Antique Pink",
   "price": 52.0,
   "variantId": "53525439545610",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_40_Altrosa_Antique-Pink.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_40_Altrosa_Antique-Pink.jpg?v=1786971438&width=64",
   "hex": "#BC888A",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_40_Altrosa_Antique-Pink.jpg?v=1786971438&width=96",
   "poz": "38% 62%"
  },
  {
   "cod": "41M",
   "nume": "Dark Denim",
   "eticheta": "41M Dark Denim",
   "price": 52.0,
   "variantId": "53525439578378",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_41M_Jeansblau-Dark-Denim.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_41M_Jeansblau-Dark-Denim.jpg?v=1786971438&width=64",
   "hex": "#3D597B",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_41M_Jeansblau-Dark-Denim.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "42M",
   "nume": "Light Grey",
   "eticheta": "42M Light Grey",
   "price": 52.0,
   "variantId": "53525439611146",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_42M-Hellgrau-Light-Grey.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_42M-Hellgrau-Light-Grey.jpg?v=1786971438&width=64",
   "hex": "#989292",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_42M-Hellgrau-Light-Grey.jpg?v=1786971438&width=96",
   "poz": "38% 88%"
  },
  {
   "cod": "43",
   "nume": "Pastel Blue",
   "eticheta": "43 Pastel Blue",
   "price": 52.0,
   "variantId": "53525439643914",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_43_Pastellblau_Pastel_Blue.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_43_Pastellblau_Pastel_Blue.jpg?v=1786971438&width=64",
   "hex": "#80B4E0",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_43_Pastellblau_Pastel_Blue.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "44",
   "nume": "Peach",
   "eticheta": "44 Peach",
   "price": 52.0,
   "variantId": "53525439676682",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_44_Pfirsich_Peach.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_44_Pfirsich_Peach.jpg?v=1786971438&width=64",
   "hex": "#ECBE98",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_44_Pfirsich_Peach.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "46",
   "nume": "Basalt Blue",
   "eticheta": "46 Basalt Blue",
   "price": 52.0,
   "variantId": "53525439709450",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_46_Basaltblau_Basalt-Blue.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_46_Basaltblau_Basalt-Blue.jpg?v=1786971438&width=64",
   "hex": "#364E60",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_46_Basaltblau_Basalt-Blue.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "47M",
   "nume": "Muscat",
   "eticheta": "47M Muscat",
   "price": 52.0,
   "variantId": "53525439742218",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_47M_Muskat_Muscat.jpg?v=1786971439&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_47M_Muskat_Muscat.jpg?v=1786971439&width=64",
   "hex": "#756658",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_47M_Muskat_Muscat.jpg?v=1786971439&width=96",
   "poz": "50% 25%"
  },
  {
   "cod": "48M",
   "nume": "Macadamia",
   "eticheta": "48M Macadamia",
   "price": 52.0,
   "variantId": "53525439774986",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_48M_Macadamia.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_48M_Macadamia.jpg?v=1786971438&width=64",
   "hex": "#6F5448",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_48M_Macadamia.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "49M",
   "nume": "Crocus",
   "eticheta": "49M Crocus",
   "price": 52.0,
   "variantId": "53525439807754",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_49M_Krokus_Crocus.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_49M_Krokus_Crocus.jpg?v=1786971438&width=64",
   "hex": "#706684",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_49M_Krokus_Crocus.jpg?v=1786971438&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "50",
   "nume": "Aubergine",
   "eticheta": "50 Aubergine",
   "price": 52.0,
   "variantId": "53525439840522",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_50_Aubergine.jpg?v=1786971439&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_50_Aubergine.jpg?v=1786971439&width=64",
   "hex": "#36252E",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_50_Aubergine.jpg?v=1786971439&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "51M",
   "nume": "Moss Green",
   "eticheta": "51M Moss Green",
   "price": 52.0,
   "variantId": "53525439873290",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_51M_Moosgruen_Moss-Green.jpg?v=1786971439&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_51M_Moosgruen_Moss-Green.jpg?v=1786971439&width=64",
   "hex": "#465B59",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_51M_Moosgruen_Moss-Green.jpg?v=1786971439&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "52",
   "nume": "Grass Green",
   "eticheta": "52 Grass Green",
   "price": 52.0,
   "variantId": "53525439906058",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_52_Grasgruen_Grass-Green.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_52_Grasgruen_Grass-Green.jpg?v=1786971438&width=64",
   "hex": "#065747",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_52_Grasgruen_Grass-Green.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "53M",
   "nume": "Night Blue",
   "eticheta": "53M Night Blue",
   "price": 52.0,
   "variantId": "53525439938826",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_53M_Nachtblau_Night_Blue.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_53M_Nachtblau_Night_Blue.jpg?v=1786971438&width=64",
   "hex": "#2B3F6A",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_53M_Nachtblau_Night_Blue.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "54M",
   "nume": "Ice Blue",
   "eticheta": "54M Ice Blue",
   "price": 52.0,
   "variantId": "53525439971594",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_54M_Eisblau_Ice_Blue.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_54M_Eisblau_Ice_Blue.jpg?v=1786971438&width=64",
   "hex": "#747D91",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_54M_Eisblau_Ice_Blue.jpg?v=1786971438&width=96",
   "poz": "38% 62%"
  },
  {
   "cod": "55",
   "nume": "Lagoon Blue",
   "eticheta": "55 Lagoon Blue",
   "price": 52.0,
   "variantId": "53525440004362",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_55_Lagunenblau_Lagoon_Blue.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_55_Lagunenblau_Lagoon_Blue.jpg?v=1786971438&width=64",
   "hex": "#224059",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_55_Lagunenblau_Lagoon_Blue.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "56",
   "nume": "Burgundy",
   "eticheta": "56 Burgundy",
   "price": 52.0,
   "variantId": "53525440037130",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_56_Burgund_Burgundy.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_56_Burgund_Burgundy.jpg?v=1786971438&width=64",
   "hex": "#6F1423",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_56_Burgund_Burgundy.jpg?v=1786971438&width=96",
   "poz": "38% 12%"
  },
  {
   "cod": "57M",
   "nume": "Marble",
   "eticheta": "57M Marble",
   "price": 52.0,
   "variantId": "53525440069898",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_57M_Marmor_Marble.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_57M_Marmor_Marble.jpg?v=1786971438&width=64",
   "hex": "#A7A7A8",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_57M_Marmor_Marble.jpg?v=1786971438&width=96",
   "poz": "50% 88%"
  },
  {
   "cod": "58M",
   "nume": "Walnut",
   "eticheta": "58M Walnut",
   "price": 52.0,
   "variantId": "53525440102666",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/lamana-como-58m.jpg?v=1786971444&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/lamana-como-58m.jpg?v=1786971444&width=64",
   "hex": "#615650",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/lamana-como-58m.jpg?v=1786971444&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "62",
   "nume": "Rose Quartz",
   "eticheta": "62 Rose Quartz",
   "price": 52.0,
   "variantId": "53525440135434",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_62_Rosenquarz_Rose_Quartz.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_62_Rosenquarz_Rose_Quartz.jpg?v=1786971438&width=64",
   "hex": "#A3949B",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_62_Rosenquarz_Rose_Quartz.jpg?v=1786971438&width=96",
   "poz": "50% 100%"
  },
  {
   "cod": "64M",
   "nume": "Sage",
   "eticheta": "64M Sage",
   "price": 52.0,
   "variantId": "53525440168202",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_64M_Salbei_Sage.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_64M_Salbei_Sage.jpg?v=1786971438&width=64",
   "hex": "#67766C",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_64M_Salbei_Sage.jpg?v=1786971438&width=96",
   "poz": "38% 88%"
  },
  {
   "cod": "66",
   "nume": "Kiwi",
   "eticheta": "66 Kiwi",
   "price": 52.0,
   "variantId": "53525440200970",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_66_Kiwi.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_66_Kiwi.jpg?v=1786971438&width=64",
   "hex": "#535B1B",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_66_Kiwi.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "67",
   "nume": "Mustard",
   "eticheta": "67 Mustard",
   "price": 52.0,
   "variantId": "53525440233738",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_67_Senf_Mustard.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_67_Senf_Mustard.jpg?v=1786971438&width=64",
   "hex": "#B18E05",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_67_Senf_Mustard.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "69",
   "nume": "Fir",
   "eticheta": "69 Fir",
   "price": 52.0,
   "variantId": "53525440266506",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_69_Tanne_Fir.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_69_Tanne_Fir.jpg?v=1786971438&width=64",
   "hex": "#383932",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_69_Tanne_Fir.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "70M",
   "nume": "Fern",
   "eticheta": "70M Fern",
   "price": 52.0,
   "variantId": "53525440299274",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_70M_Farn_Fern.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_70M_Farn_Fern.jpg?v=1786971438&width=64",
   "hex": "#897E59",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_70M_Farn_Fern.jpg?v=1786971438&width=96",
   "poz": "38% 25%"
  },
  {
   "cod": "72",
   "nume": "Cherry Blossom",
   "eticheta": "72 Cherry Blossom",
   "price": 52.0,
   "variantId": "53525440332042",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_72_Kirschbluete_Cherry-Blossom.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_72_Kirschbluete_Cherry-Blossom.jpg?v=1786971438&width=64",
   "hex": "#CCA8BB",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_72_Kirschbluete_Cherry-Blossom.jpg?v=1786971438&width=96",
   "poz": "50% 88%"
  },
  {
   "cod": "73M",
   "nume": "Rust",
   "eticheta": "73M Rust",
   "price": 52.0,
   "variantId": "53525440364810",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/lamana-como-73m.jpg?v=1786971444&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/lamana-como-73m.jpg?v=1786971444&width=64",
   "hex": "#48231D",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/lamana-como-73m.jpg?v=1786971444&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "74M",
   "nume": "Seagrass",
   "eticheta": "74M Seagrass",
   "price": 52.0,
   "variantId": "53525440397578",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/lamana-como-74m.jpg?v=1786971444&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/lamana-como-74m.jpg?v=1786971444&width=64",
   "hex": "#3F3626",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/lamana-como-74m.jpg?v=1786971444&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "75M",
   "nume": "Amazonas",
   "eticheta": "75M Amazonas",
   "price": 52.0,
   "variantId": "53525440430346",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_75M_Amazonas.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_75M_Amazonas.jpg?v=1786971438&width=64",
   "hex": "#2E414D",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_75M_Amazonas.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "76M",
   "nume": "Glacier",
   "eticheta": "76M Glacier",
   "price": 52.0,
   "variantId": "53525440463114",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_76M_Gletscherblau_Glacier.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_76M_Gletscherblau_Glacier.jpg?v=1786971438&width=64",
   "hex": "#9BA3A9",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Lamana-Como_76M_Gletscherblau_Glacier.jpg?v=1786971438&width=96",
   "poz": "50% 88%"
  },
  {
   "cod": "77M",
   "nume": "Azalea",
   "eticheta": "77M Azalea",
   "price": 52.0,
   "variantId": "53525440495882",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/lamana-como-77m.jpg?v=1786971444&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/lamana-como-77m.jpg?v=1786971444&width=64",
   "hex": "#7B3967",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/lamana-como-77m.jpg?v=1786971444&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "78",
   "nume": "Ruby",
   "eticheta": "78 Ruby",
   "price": 52.0,
   "variantId": "53525440528650",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/lamana-como-78-rubin-ruby.jpg?v=1786971438&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/lamana-como-78-rubin-ruby.jpg?v=1786971438&width=64",
   "hex": "#611027",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/lamana-como-78-rubin-ruby.jpg?v=1786971438&width=96",
   "poz": "50% 12%"
  },
  {
   "cod": "79M",
   "nume": "Magnolia",
   "eticheta": "79M Magnolia",
   "price": 52.0,
   "variantId": "53525440561418",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/lamana-como-79m.jpg?v=1786971444&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/lamana-como-79m.jpg?v=1786971444&width=64",
   "hex": "#B99DB5",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/lamana-como-79m.jpg?v=1786971444&width=96",
   "poz": "50% 88%"
  }
 ],
 "kal-01-sayama": [
  {
   "cod": "300",
   "nume": "Bordeaux",
   "eticheta": "300 Bordeaux",
   "price": 50.0,
   "variantId": "53525437153546",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324.jpg?v=1786970946&width=64",
   "hex": "#4D182F",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324.jpg?v=1786970946&width=96",
   "poz": "62% 50%"
  },
  {
   "cod": "301",
   "nume": "Ruby",
   "eticheta": "301 Ruby",
   "price": 50.0,
   "variantId": "53525437186314",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_1.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_1.jpg?v=1786970946&width=64",
   "hex": "#871A26",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_1.jpg?v=1786970946&width=96",
   "poz": "12% 38%"
  },
  {
   "cod": "302",
   "nume": "Blush",
   "eticheta": "302 Blush",
   "price": 50.0,
   "variantId": "53525437219082",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_2.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_2.jpg?v=1786970946&width=64",
   "hex": "#D46D6D",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_2.jpg?v=1786970946&width=96",
   "poz": "75% 38%"
  },
  {
   "cod": "303",
   "nume": "Rosé",
   "eticheta": "303 Rosé",
   "price": 50.0,
   "variantId": "53525437251850",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_3.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_3.jpg?v=1786970946&width=64",
   "hex": "#BE9997",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_3.jpg?v=1786970946&width=96",
   "poz": "12% 50%"
  },
  {
   "cod": "304",
   "nume": "Scarlet",
   "eticheta": "304 Scarlet",
   "price": 50.0,
   "variantId": "53525437284618",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_4.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_4.jpg?v=1786970946&width=64",
   "hex": "#C30828",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_4.jpg?v=1786970946&width=96",
   "poz": "12% 50%"
  },
  {
   "cod": "305",
   "nume": "Turmeric",
   "eticheta": "305 Turmeric",
   "price": 50.0,
   "variantId": "53525437317386",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_5.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_5.jpg?v=1786970946&width=64",
   "hex": "#BC5912",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_5.jpg?v=1786970946&width=96",
   "poz": "12% 50%"
  },
  {
   "cod": "306",
   "nume": "Curry",
   "eticheta": "306 Curry",
   "price": 50.0,
   "variantId": "53525437350154",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_6.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_6.jpg?v=1786970946&width=64",
   "hex": "#BB831E",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_6.jpg?v=1786970946&width=96",
   "poz": "12% 50%"
  },
  {
   "cod": "307",
   "nume": "Cream",
   "eticheta": "307 Cream",
   "price": 50.0,
   "variantId": "53525437382922",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_7.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_7.jpg?v=1786970946&width=64",
   "hex": "#AD9E95",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_7.jpg?v=1786970946&width=96",
   "poz": "50% 100%"
  },
  {
   "cod": "308",
   "nume": "Ecru",
   "eticheta": "308 Ecru",
   "price": 50.0,
   "variantId": "53525437415690",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_8.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_8.jpg?v=1786970946&width=64",
   "hex": "#ABA8A0",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_8.jpg?v=1786970946&width=96",
   "poz": "0% 62%"
  },
  {
   "cod": "309",
   "nume": "Taupe",
   "eticheta": "309 Taupe",
   "price": 50.0,
   "variantId": "53525437448458",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_9.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_9.jpg?v=1786970946&width=64",
   "hex": "#A18B7F",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_9.jpg?v=1786970946&width=96",
   "poz": "12% 50%"
  },
  {
   "cod": "310",
   "nume": "Almond",
   "eticheta": "310 Almond",
   "price": 50.0,
   "variantId": "53525437481226",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_10.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_10.jpg?v=1786970946&width=64",
   "hex": "#967261",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_10.jpg?v=1786970946&width=96",
   "poz": "12% 50%"
  },
  {
   "cod": "311",
   "nume": "Antracite",
   "eticheta": "311 Antracite",
   "price": 50.0,
   "variantId": "53525437513994",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_11.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_11.jpg?v=1786970946&width=64",
   "hex": "#535254",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_11.jpg?v=1786970946&width=96",
   "poz": "12% 50%"
  },
  {
   "cod": "312",
   "nume": "Black",
   "eticheta": "312 Black",
   "price": 50.0,
   "variantId": "53525437546762",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_12.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_12.jpg?v=1786970946&width=64",
   "hex": "#322F37",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_12.jpg?v=1786970946&width=96",
   "poz": "12% 50%"
  },
  {
   "cod": "313",
   "nume": "Greige",
   "eticheta": "313 Greige",
   "price": 50.0,
   "variantId": "53525437579530",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_13.jpg?v=1786970947&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_13.jpg?v=1786970947&width=64",
   "hex": "#767270",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_13.jpg?v=1786970947&width=96",
   "poz": "50% 100%"
  },
  {
   "cod": "314",
   "nume": "Sage",
   "eticheta": "314 Sage",
   "price": 50.0,
   "variantId": "53525437612298",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_14.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_14.jpg?v=1786970946&width=64",
   "hex": "#989D90",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_14.jpg?v=1786970946&width=96",
   "poz": "12% 50%"
  },
  {
   "cod": "315",
   "nume": "Aloe Vera",
   "eticheta": "315 Aloe Vera",
   "price": 50.0,
   "variantId": "53525437645066",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_15.jpg?v=1786970947&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_15.jpg?v=1786970947&width=64",
   "hex": "#6A887D",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_15.jpg?v=1786970947&width=96",
   "poz": "62% 50%"
  },
  {
   "cod": "316",
   "nume": "Olive",
   "eticheta": "316 Olive",
   "price": 50.0,
   "variantId": "53525437677834",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_16.jpg?v=1786970947&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_16.jpg?v=1786970947&width=64",
   "hex": "#5B5638",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_16.jpg?v=1786970947&width=96",
   "poz": "25% 38%"
  },
  {
   "cod": "317",
   "nume": "Sea Green",
   "eticheta": "317 Sea Green",
   "price": 50.0,
   "variantId": "53525437710602",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_17.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_17.jpg?v=1786970946&width=64",
   "hex": "#263631",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_17.jpg?v=1786970946&width=96",
   "poz": "25% 50%"
  },
  {
   "cod": "318",
   "nume": "Glacier",
   "eticheta": "318 Glacier",
   "price": 50.0,
   "variantId": "53525437743370",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_18.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_18.jpg?v=1786970946&width=64",
   "hex": "#8FA1B0",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_18.jpg?v=1786970946&width=96",
   "poz": "75% 50%"
  },
  {
   "cod": "319",
   "nume": "Horizon",
   "eticheta": "319 Horizon",
   "price": 50.0,
   "variantId": "53525437776138",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_19.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_19.jpg?v=1786970946&width=64",
   "hex": "#7C9BBE",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_19.jpg?v=1786970946&width=96",
   "poz": "25% 50%"
  },
  {
   "cod": "320",
   "nume": "Navy",
   "eticheta": "320 Navy",
   "price": 50.0,
   "variantId": "53525437808906",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_20.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_20.jpg?v=1786970946&width=64",
   "hex": "#202A47",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_20.jpg?v=1786970946&width=96",
   "poz": "75% 38%"
  },
  {
   "cod": "321",
   "nume": "Grape",
   "eticheta": "321 Grape",
   "price": 50.0,
   "variantId": "53525437841674",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_21.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_21.jpg?v=1786970946&width=64",
   "hex": "#302650",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_21.jpg?v=1786970946&width=96",
   "poz": "25% 50%"
  },
  {
   "cod": "322",
   "nume": "Lavender",
   "eticheta": "322 Lavender",
   "price": 50.0,
   "variantId": "53525437874442",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_22.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_22.jpg?v=1786970946&width=64",
   "hex": "#9380B4",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_22.jpg?v=1786970946&width=96",
   "poz": "25% 50%"
  },
  {
   "cod": "323",
   "nume": "Plum",
   "eticheta": "323 Plum",
   "price": 50.0,
   "variantId": "53525437907210",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_23.jpg?v=1786970947&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_23.jpg?v=1786970947&width=64",
   "hex": "#651F70",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA-2042324_23.jpg?v=1786970947&width=96",
   "poz": "25% 50%"
  },
  {
   "cod": "324",
   "nume": "Silver",
   "eticheta": "324 Silver",
   "price": 50.0,
   "variantId": "53525437939978",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA---BABYLAMA-und-HIGHLAND-WOLLE-2042324.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA---BABYLAMA-und-HIGHLAND-WOLLE-2042324.jpg?v=1786970946&width=64",
   "hex": "#9CA4B7",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA---BABYLAMA-und-HIGHLAND-WOLLE-2042324.jpg?v=1786970946&width=96",
   "poz": "75% 25%"
  },
  {
   "cod": "325",
   "nume": "Rose Quartz",
   "eticheta": "325 Rose Quartz",
   "price": 50.0,
   "variantId": "53525437972746",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA---BABYLAMA-und-HIGHLAND-WOLLE-2042324_1.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA---BABYLAMA-und-HIGHLAND-WOLLE-2042324_1.jpg?v=1786970946&width=64",
   "hex": "#64465A",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA---BABYLAMA-und-HIGHLAND-WOLLE-2042324_1.jpg?v=1786970946&width=96",
   "poz": "25% 25%"
  },
  {
   "cod": "326",
   "nume": "Denim",
   "eticheta": "326 Denim",
   "price": 50.0,
   "variantId": "53525438005514",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA---BABYLAMA-und-HIGHLAND-WOLLE-2042324_2.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA---BABYLAMA-und-HIGHLAND-WOLLE-2042324_2.jpg?v=1786970946&width=64",
   "hex": "#4A5779",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA---BABYLAMA-und-HIGHLAND-WOLLE-2042324_2.jpg?v=1786970946&width=96",
   "poz": "25% 25%"
  },
  {
   "cod": "327",
   "nume": "Teal",
   "eticheta": "327 Teal",
   "price": 50.0,
   "variantId": "53525438038282",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA---BABYLAMA-und-HIGHLAND-WOLLE-2042324_3.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA---BABYLAMA-und-HIGHLAND-WOLLE-2042324_3.jpg?v=1786970946&width=64",
   "hex": "#2C5358",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA---BABYLAMA-und-HIGHLAND-WOLLE-2042324_3.jpg?v=1786970946&width=96",
   "poz": "25% 25%"
  },
  {
   "cod": "328",
   "nume": "Pistachio",
   "eticheta": "328 Pistachio",
   "price": 50.0,
   "variantId": "53525438071050",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA---BABYLAMA-und-HIGHLAND-WOLLE-2042324_4.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA---BABYLAMA-und-HIGHLAND-WOLLE-2042324_4.jpg?v=1786970946&width=64",
   "hex": "#A3AD7E",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA---BABYLAMA-und-HIGHLAND-WOLLE-2042324_4.jpg?v=1786970946&width=96",
   "poz": "25% 25%"
  },
  {
   "cod": "329",
   "nume": "Moss Green",
   "eticheta": "329 Moss Green",
   "price": 50.0,
   "variantId": "53525438103818",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA---BABYLAMA-und-HIGHLAND-WOLLE-2042324_5.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA---BABYLAMA-und-HIGHLAND-WOLLE-2042324_5.jpg?v=1786970946&width=64",
   "hex": "#40453E",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1612042324-SAYAMA---BABYLAMA-und-HIGHLAND-WOLLE-2042324_5.jpg?v=1786970946&width=96",
   "poz": "25% 25%"
  },
  {
   "cod": "330",
   "nume": "Tintenblau",
   "eticheta": "330 Tintenblau",
   "price": 50.0,
   "variantId": "53525438136586",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Sayama330_1.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Sayama330_1.jpg?v=1786970946&width=64",
   "hex": "#193BAB",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Sayama330_1.jpg?v=1786970946&width=96",
   "poz": "12% 38%"
  },
  {
   "cod": "331",
   "nume": "Schokolade",
   "eticheta": "331 Schokolade",
   "price": 50.0,
   "variantId": "53525438169354",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Sayama331_1.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Sayama331_1.jpg?v=1786970946&width=64",
   "hex": "#2E242B",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Sayama331_1.jpg?v=1786970946&width=96",
   "poz": "12% 38%"
  },
  {
   "cod": "332",
   "nume": "Terrakotta",
   "eticheta": "332 Terrakotta",
   "price": 50.0,
   "variantId": "53525438202122",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Sayama332_1.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Sayama332_1.jpg?v=1786970946&width=64",
   "hex": "#AC3428",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Sayama332_1.jpg?v=1786970946&width=96",
   "poz": "12% 38%"
  },
  {
   "cod": "333",
   "nume": "Kohle",
   "eticheta": "333 Kohle",
   "price": 50.0,
   "variantId": "53525438234890",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Sayama333_1.jpg?v=1786970946&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Sayama333_1.jpg?v=1786970946&width=64",
   "hex": "#2E3648",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Sayama333_1.jpg?v=1786970946&width=96",
   "poz": "12% 38%"
  }
 ],
 "kal-01-pearl-mohair": [
  {
   "cod": "100",
   "nume": "Ivory",
   "eticheta": "100 Ivory",
   "price": 56.0,
   "variantId": "53525426307338",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Screenshot2026-01-30at11.54.47_ad265500-e8aa-4d08-805a-dadbbbc876a9.png?v=1786970792&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Screenshot2026-01-30at11.54.47_ad265500-e8aa-4d08-805a-dadbbbc876a9.png?v=1786970792&width=64",
   "hex": "#A3A1AB"
  },
  {
   "cod": "101",
   "nume": "Oatmeal",
   "eticheta": "101 Oatmeal",
   "price": 56.0,
   "variantId": "53525426340106",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/101_OATMEAL_d31cefdb-7d3b-4cdf-97d7-4dbc593a866f.jpg?v=1786970792&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/101_OATMEAL_d31cefdb-7d3b-4cdf-97d7-4dbc593a866f.jpg?v=1786970792&width=64",
   "hex": "#B2B8D2"
  },
  {
   "cod": "102",
   "nume": "Vanilla",
   "eticheta": "102 Vanilla",
   "price": 56.0,
   "variantId": "53525426372874",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Screenshot2026-01-30at11.44.42_52056080-1373-4a4d-ba57-8b5f8ef7a812.png?v=1786970792&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Screenshot2026-01-30at11.44.42_52056080-1373-4a4d-ba57-8b5f8ef7a812.png?v=1786970792&width=64",
   "hex": "#A89790",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Screenshot2026-01-30at11.44.42_52056080-1373-4a4d-ba57-8b5f8ef7a812.png?v=1786970792&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "103",
   "nume": "Almond",
   "eticheta": "103 Almond",
   "price": 56.0,
   "variantId": "53525426405642",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/103_ALMOND_0c6e7db3-d1c1-4bec-aaa3-05024821efc8.jpg?v=1786970792&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/103_ALMOND_0c6e7db3-d1c1-4bec-aaa3-05024821efc8.jpg?v=1786970792&width=64",
   "hex": "#BC8D77",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/103_ALMOND_0c6e7db3-d1c1-4bec-aaa3-05024821efc8.jpg?v=1786970792&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "105",
   "nume": "Tiramisu",
   "eticheta": "105 Tiramisu",
   "price": 56.0,
   "variantId": "53529446318346",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-039.jpg?v=1787045368&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-039.jpg?v=1787045368&width=64",
   "hex": "#5F3625",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-039.jpg?v=1787045368&width=96",
   "poz": "50% 25%"
  },
  {
   "cod": "200",
   "nume": "Organdy",
   "eticheta": "200 Organdy",
   "price": 56.0,
   "variantId": "53529446351114",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-034.jpg?v=1787045367&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-034.jpg?v=1787045367&width=64",
   "hex": "#AA9DAD"
  },
  {
   "cod": "201",
   "nume": "Baby Pink",
   "eticheta": "201 Baby Pink",
   "price": 56.0,
   "variantId": "53525426438410",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-027_4b55ba16-5cdb-44d4-88bf-d6a54bc80aa4.jpg?v=1786970792&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-027_4b55ba16-5cdb-44d4-88bf-d6a54bc80aa4.jpg?v=1786970792&width=64",
   "hex": "#D2B1C4",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-027_4b55ba16-5cdb-44d4-88bf-d6a54bc80aa4.jpg?v=1786970792&width=96",
   "poz": "38% 50%"
  },
  {
   "cod": "202",
   "nume": "Lilac",
   "eticheta": "202 Lilac",
   "price": 56.0,
   "variantId": "53529446383882",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-025.jpg?v=1787045368&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-025.jpg?v=1787045368&width=64",
   "hex": "#C99ACC",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-025.jpg?v=1787045368&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "203",
   "nume": "Rose",
   "eticheta": "203 Rose",
   "price": 56.0,
   "variantId": "53525426471178",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/203_ROSE_8403faef-afae-417d-b61a-2e627b4f39dd.jpg?v=1786970792&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/203_ROSE_8403faef-afae-417d-b61a-2e627b4f39dd.jpg?v=1786970792&width=64",
   "hex": "#DE829B",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/203_ROSE_8403faef-afae-417d-b61a-2e627b4f39dd.jpg?v=1786970792&width=96",
   "poz": "50% 25%"
  },
  {
   "cod": "204",
   "nume": "Dusty Rose",
   "eticheta": "204 Dusty Rose",
   "price": 56.0,
   "variantId": "53529446416650",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-026.jpg?v=1787045367&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-026.jpg?v=1787045367&width=64",
   "hex": "#A65A65",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-026.jpg?v=1787045367&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "205",
   "nume": "Flamingo",
   "eticheta": "205 Flamingo",
   "price": 56.0,
   "variantId": "53529446449418",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-022.jpg?v=1787045369&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-022.jpg?v=1787045369&width=64",
   "hex": "#CD076A",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-022.jpg?v=1787045369&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "300",
   "nume": "Poppy",
   "eticheta": "300 Poppy",
   "price": 56.0,
   "variantId": "53525426503946",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Screenshot2026-01-30at12.11.49_562b7e24-1031-4706-8d4a-15750a83f091.png?v=1786970792&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Screenshot2026-01-30at12.11.49_562b7e24-1031-4706-8d4a-15750a83f091.png?v=1786970792&width=64",
   "hex": "#DC1B17",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Screenshot2026-01-30at12.11.49_562b7e24-1031-4706-8d4a-15750a83f091.png?v=1786970792&width=96",
   "poz": "50% 38%"
  },
  {
   "cod": "301",
   "nume": "Terracotta",
   "eticheta": "301 Terracotta",
   "price": 56.0,
   "variantId": "53529446482186",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-010.jpg?v=1787045369&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-010.jpg?v=1787045369&width=64",
   "hex": "#C03C1D",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-010.jpg?v=1787045369&width=96",
   "poz": "50% 25%"
  },
  {
   "cod": "302",
   "nume": "Apricot",
   "eticheta": "302 Apricot",
   "price": 56.0,
   "variantId": "53529446514954",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-020.jpg?v=1787045369&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-020.jpg?v=1787045369&width=64",
   "hex": "#E77E10",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-020.jpg?v=1787045369&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "308",
   "nume": "Banana",
   "eticheta": "308 Banana",
   "price": 56.0,
   "variantId": "53525426536714",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1-250411-013_d4819e22-d060-4ae8-a31e-feb069a4003a.jpg?v=1786970791&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1-250411-013_d4819e22-d060-4ae8-a31e-feb069a4003a.jpg?v=1786970791&width=64",
   "hex": "#E9DDA3",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1-250411-013_d4819e22-d060-4ae8-a31e-feb069a4003a.jpg?v=1786970791&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "311",
   "nume": "Peach",
   "eticheta": "311 Peach",
   "price": 56.0,
   "variantId": "53525426569482",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/311_PEACH_754d65e5-0d67-4e67-af4a-8bab5c5b0aa3.jpg?v=1786970792&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/311_PEACH_754d65e5-0d67-4e67-af4a-8bab5c5b0aa3.jpg?v=1786970792&width=64",
   "hex": "#F0D0BC",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/311_PEACH_754d65e5-0d67-4e67-af4a-8bab5c5b0aa3.jpg?v=1786970792&width=96",
   "poz": "50% 38%"
  },
  {
   "cod": "400",
   "nume": "Anemone",
   "eticheta": "400 Anemone",
   "price": 56.0,
   "variantId": "53529446547722",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/IMG_6819.jpg?v=1787045369&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/IMG_6819.jpg?v=1787045369&width=64",
   "hex": "#9687D7",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/IMG_6819.jpg?v=1787045369&width=96",
   "poz": "50% 38%"
  },
  {
   "cod": "401",
   "nume": "Lavender",
   "eticheta": "401 Lavender",
   "price": 56.0,
   "variantId": "53529446580490",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-008_1.jpg?v=1787045370&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-008_1.jpg?v=1787045370&width=64",
   "hex": "#814DC6",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-008_1.jpg?v=1787045370&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "402",
   "nume": "Grape",
   "eticheta": "402 Grape",
   "price": 56.0,
   "variantId": "53529446613258",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1-240430-005.jpg?v=1787045370&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1-240430-005.jpg?v=1787045370&width=64",
   "hex": "#643FC1",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1-240430-005.jpg?v=1787045370&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "403",
   "nume": "Mauve",
   "eticheta": "403 Mauve",
   "price": 56.0,
   "variantId": "53529446646026",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-024.jpg?v=1787045371&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-024.jpg?v=1787045371&width=64",
   "hex": "#AA4CC7",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-024.jpg?v=1787045371&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "500",
   "nume": "Mist",
   "eticheta": "500 Mist",
   "price": 56.0,
   "variantId": "53525426929930",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-007_62daa43c-4810-40d6-b573-9322c0996cce.jpg?v=1786970792&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-007_62daa43c-4810-40d6-b573-9322c0996cce.jpg?v=1786970792&width=64",
   "hex": "#B4C3DD",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-007_62daa43c-4810-40d6-b573-9322c0996cce.jpg?v=1786970792&width=96",
   "poz": "50% 38%"
  },
  {
   "cod": "501",
   "nume": "Sky Blue",
   "eticheta": "501 Sky Blue",
   "price": 56.0,
   "variantId": "53529446678794",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-001.jpg?v=1787045370&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-001.jpg?v=1787045370&width=64",
   "hex": "#A1BDE0",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-001.jpg?v=1787045370&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "502",
   "nume": "Dusty Blue",
   "eticheta": "502 Dusty Blue",
   "price": 56.0,
   "variantId": "53529446711562",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-006.jpg?v=1787045371&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-006.jpg?v=1787045371&width=64",
   "hex": "#6877A1",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-006.jpg?v=1787045371&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "503",
   "nume": "Azure",
   "eticheta": "503 Azure",
   "price": 56.0,
   "variantId": "53529446744330",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1-240430-008.jpg?v=1787045373&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1-240430-008.jpg?v=1787045373&width=64",
   "hex": "#426CB9",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1-240430-008.jpg?v=1787045373&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "505",
   "nume": "Electric Blue",
   "eticheta": "505 Electric Blue",
   "price": 56.0,
   "variantId": "53529446777098",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-031.jpg?v=1787045372&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-031.jpg?v=1787045372&width=64",
   "hex": "#0938A6",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-031.jpg?v=1787045372&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "506",
   "nume": "Denim",
   "eticheta": "506 Denim",
   "price": 56.0,
   "variantId": "53529446809866",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-034.jpg?v=1787045373&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-034.jpg?v=1787045373&width=64",
   "hex": "#23336D",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-034.jpg?v=1787045373&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "507",
   "nume": "Midnight",
   "eticheta": "507 Midnight",
   "price": 56.0,
   "variantId": "53525426602250",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Screenshot2026-01-30at11.42.57_cf2381cd-8cb0-4fdd-84fe-ccbf1c32728f.png?v=1786970792&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Screenshot2026-01-30at11.42.57_cf2381cd-8cb0-4fdd-84fe-ccbf1c32728f.png?v=1786970792&width=64",
   "hex": "#0C1237",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Screenshot2026-01-30at11.42.57_cf2381cd-8cb0-4fdd-84fe-ccbf1c32728f.png?v=1786970792&width=96",
   "poz": "50% 38%"
  },
  {
   "cod": "601",
   "nume": "Slate",
   "eticheta": "601 Slate",
   "price": 56.0,
   "variantId": "53525426962698",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-018_d2068a1e-7134-48e1-81e0-978f53c6833e.jpg?v=1786970793&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-018_d2068a1e-7134-48e1-81e0-978f53c6833e.jpg?v=1786970793&width=64",
   "hex": "#7A7A8E",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-018_d2068a1e-7134-48e1-81e0-978f53c6833e.jpg?v=1786970793&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "602",
   "nume": "Charcoal",
   "eticheta": "602 Charcoal",
   "price": 56.0,
   "variantId": "53525426635018",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/602_CHARCOAL_0308be0a-16e1-4965-811c-6389e228012f.jpg?v=1786970792&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/602_CHARCOAL_0308be0a-16e1-4965-811c-6389e228012f.jpg?v=1786970792&width=64",
   "hex": "#5A5B6C",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/602_CHARCOAL_0308be0a-16e1-4965-811c-6389e228012f.jpg?v=1786970792&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "603",
   "nume": "Black",
   "eticheta": "603 Black",
   "price": 56.0,
   "variantId": "53525426897162",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-035_3a21162f-9c06-44f2-bf92-3d428d72d2bd.webp?v=1786970792&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-035_3a21162f-9c06-44f2-bf92-3d428d72d2bd.webp?v=1786970792&width=64",
   "hex": "#1E1D2C",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-035_3a21162f-9c06-44f2-bf92-3d428d72d2bd.webp?v=1786970792&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "701",
   "nume": "Pistachio",
   "eticheta": "701 Pistachio",
   "price": 56.0,
   "variantId": "53525426667786",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-021_84b01385-67d4-4d7e-a1f9-8ded027a6e8c.jpg?v=1786970792&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-021_84b01385-67d4-4d7e-a1f9-8ded027a6e8c.jpg?v=1786970792&width=64",
   "hex": "#A7A451",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-021_84b01385-67d4-4d7e-a1f9-8ded027a6e8c.jpg?v=1786970792&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "702",
   "nume": "Olive",
   "eticheta": "702 Olive",
   "price": 56.0,
   "variantId": "53525426700554",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-011_32ea107d-450a-41c1-953f-1097fd08c4b2.jpg?v=1786970792&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-011_32ea107d-450a-41c1-953f-1097fd08c4b2.jpg?v=1786970792&width=64",
   "hex": "#969070",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-011_32ea107d-450a-41c1-953f-1097fd08c4b2.jpg?v=1786970792&width=96",
   "poz": "50% 25%"
  },
  {
   "cod": "703",
   "nume": "Moss",
   "eticheta": "703 Moss",
   "price": 56.0,
   "variantId": "53525426733322",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Screenshot2026-01-30at11.34.39_fbff9358-53f3-47fd-b802-bff8b5c2af9c.png?v=1786970792&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Screenshot2026-01-30at11.34.39_fbff9358-53f3-47fd-b802-bff8b5c2af9c.png?v=1786970792&width=64",
   "hex": "#565643",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Screenshot2026-01-30at11.34.39_fbff9358-53f3-47fd-b802-bff8b5c2af9c.png?v=1786970792&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "704",
   "nume": "Limeade",
   "eticheta": "704 Limeade",
   "price": 56.0,
   "variantId": "53529446875402",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-032_194a6be7-e907-4001-bf16-f88616258d11.jpg?v=1787045374&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-032_194a6be7-e907-4001-bf16-f88616258d11.jpg?v=1787045374&width=64",
   "hex": "#CBC045",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-032_194a6be7-e907-4001-bf16-f88616258d11.jpg?v=1787045374&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "712",
   "nume": "Spruce",
   "eticheta": "712 Spruce",
   "price": 56.0,
   "variantId": "53525426766090",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/712_SPRUCE_d932586d-db9f-4f08-8e37-59669db58500.jpg?v=1786970793&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/712_SPRUCE_d932586d-db9f-4f08-8e37-59669db58500.jpg?v=1786970793&width=64",
   "hex": "#879A9A",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/712_SPRUCE_d932586d-db9f-4f08-8e37-59669db58500.jpg?v=1786970793&width=96",
   "poz": "50% 38%"
  },
  {
   "cod": "713",
   "nume": "Mint Glow",
   "eticheta": "713 Mint Glow",
   "price": 56.0,
   "variantId": "53525426798858",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/713_MINT_GLOW_80f0c325-d28e-488b-9401-6c32e4553d25.jpg?v=1786970792&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/713_MINT_GLOW_80f0c325-d28e-488b-9401-6c32e4553d25.jpg?v=1786970792&width=64",
   "hex": "#CED9DB"
  },
  {
   "cod": "800",
   "nume": "Aqua",
   "eticheta": "800 Aqua",
   "price": 56.0,
   "variantId": "53529446908170",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-012.jpg?v=1787045373&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-012.jpg?v=1787045373&width=64",
   "hex": "#599AAB",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-012.jpg?v=1787045373&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "900",
   "nume": "Cherry",
   "eticheta": "900 Cherry",
   "price": 56.0,
   "variantId": "53529446940938",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-009.jpg?v=1787045373&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-009.jpg?v=1787045373&width=64",
   "hex": "#AD0519",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-009.jpg?v=1787045373&width=96",
   "poz": "50% 38%"
  },
  {
   "cod": "901",
   "nume": "Mulberry",
   "eticheta": "901 Mulberry",
   "price": 56.0,
   "variantId": "53525426831626",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-015_60ef797d-68a0-4fc8-a822-b968f82ad894.jpg?v=1786970792&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-015_60ef797d-68a0-4fc8-a822-b968f82ad894.jpg?v=1786970792&width=64",
   "hex": "#610D3C",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-015_60ef797d-68a0-4fc8-a822-b968f82ad894.jpg?v=1786970792&width=96",
   "poz": "50% 38%"
  },
  {
   "cod": "902",
   "nume": "Wine",
   "eticheta": "902 Wine",
   "price": 56.0,
   "variantId": "53525426864394",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-014_3a76c013-6791-465c-adb9-0e7f3bc4c029.jpg?v=1786970792&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-014_3a76c013-6791-465c-adb9-0e7f3bc4c029.jpg?v=1786970792&width=64",
   "hex": "#360B32",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240406-014_3a76c013-6791-465c-adb9-0e7f3bc4c029.jpg?v=1786970792&width=96",
   "poz": "50% 25%"
  }
 ],
 "kal-01-fine-merino": [
  {
   "cod": "100",
   "nume": "Ivory",
   "eticheta": "100 Ivory",
   "price": 42.0,
   "variantId": "53525422670090",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-013_2bcfce9b-b85d-44f9-87c0-a56278581142.jpg?v=1786970784&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-013_2bcfce9b-b85d-44f9-87c0-a56278581142.jpg?v=1786970784&width=64",
   "hex": "#BCB0AE"
  },
  {
   "cod": "103",
   "nume": "Almond",
   "eticheta": "103 Almond",
   "price": 42.0,
   "variantId": "53525422932234",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/103_ALMOND_1_cba10948-5065-4c20-99f6-0cf021a221d5.jpg?v=1786970785&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/103_ALMOND_1_cba10948-5065-4c20-99f6-0cf021a221d5.jpg?v=1786970785&width=64",
   "hex": "#A57453",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/103_ALMOND_1_cba10948-5065-4c20-99f6-0cf021a221d5.jpg?v=1786970785&width=96",
   "poz": "50% 38%"
  },
  {
   "cod": "106",
   "nume": "Brownie",
   "eticheta": "106 Brownie",
   "price": 42.0,
   "variantId": "53529445466378",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-028.jpg?v=1787045342&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-028.jpg?v=1787045342&width=64",
   "hex": "#3F2322",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-028.jpg?v=1787045342&width=96",
   "poz": "50% 38%"
  },
  {
   "cod": "107",
   "nume": "Walnut",
   "eticheta": "107 Walnut",
   "price": 42.0,
   "variantId": "53525422965002",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/107_WALNUT_46f22c0c-eebb-470f-885f-93473c5e21e9.jpg?v=1786970785&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/107_WALNUT_46f22c0c-eebb-470f-885f-93473c5e21e9.jpg?v=1786970785&width=64",
   "hex": "#534145",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/107_WALNUT_46f22c0c-eebb-470f-885f-93473c5e21e9.jpg?v=1786970785&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "108",
   "nume": "Hazel",
   "eticheta": "108 Hazel",
   "price": 42.0,
   "variantId": "53529445499146",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-008.jpg?v=1787045342&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-008.jpg?v=1787045342&width=64",
   "hex": "#968185",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-008.jpg?v=1787045342&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "110",
   "nume": "Nougat",
   "eticheta": "110 Nougat",
   "price": 42.0,
   "variantId": "53525422997770",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/110_NOUGAT_ea186ad8-9bd8-435c-bc23-6e788bcc7c9c.jpg?v=1786970785&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/110_NOUGAT_ea186ad8-9bd8-435c-bc23-6e788bcc7c9c.jpg?v=1786970785&width=64",
   "hex": "#96786B",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/110_NOUGAT_ea186ad8-9bd8-435c-bc23-6e788bcc7c9c.jpg?v=1786970785&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "113",
   "nume": "Sand",
   "eticheta": "113 Sand",
   "price": 42.0,
   "variantId": "53529445531914",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-005.jpg?v=1787045342&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-005.jpg?v=1787045342&width=64",
   "hex": "#A89DA3"
  },
  {
   "cod": "200",
   "nume": "Organdy",
   "eticheta": "200 Organdy",
   "price": 42.0,
   "variantId": "53525422702858",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-025_3bed320d-3fd6-4fc9-9981-ed15f1218017.webp?v=1786970785&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-025_3bed320d-3fd6-4fc9-9981-ed15f1218017.webp?v=1786970785&width=64",
   "hex": "#A999A7"
  },
  {
   "cod": "201",
   "nume": "Baby Pink",
   "eticheta": "201 Baby Pink",
   "price": 42.0,
   "variantId": "53529445564682",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/10-251022-004.jpg?v=1787045342&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/10-251022-004.jpg?v=1787045342&width=64",
   "hex": "#C0A3B8",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/10-251022-004.jpg?v=1787045342&width=96",
   "poz": "50% 62%"
  },
  {
   "cod": "205",
   "nume": "Flamingo",
   "eticheta": "205 Flamingo",
   "price": 42.0,
   "variantId": "53529445597450",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-007.jpg?v=1787045343&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-007.jpg?v=1787045343&width=64",
   "hex": "#C00847",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-007.jpg?v=1787045343&width=96",
   "poz": "50% 38%"
  },
  {
   "cod": "207",
   "nume": "Blush",
   "eticheta": "207 Blush",
   "price": 42.0,
   "variantId": "53529445630218",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-019.jpg?v=1787045344&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-019.jpg?v=1787045344&width=64",
   "hex": "#D092A8",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-019.jpg?v=1787045344&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "300",
   "nume": "Poppy",
   "eticheta": "300 Poppy",
   "price": 42.0,
   "variantId": "53525422899466",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/300_POPPY_15587615-1814-4909-8189-683c22c4031d.jpg?v=1786970785&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/300_POPPY_15587615-1814-4909-8189-683c22c4031d.jpg?v=1786970785&width=64",
   "hex": "#DC261F",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/300_POPPY_15587615-1814-4909-8189-683c22c4031d.jpg?v=1786970785&width=96",
   "poz": "50% 38%"
  },
  {
   "cod": "311",
   "nume": "Peach",
   "eticheta": "311 Peach",
   "price": 42.0,
   "variantId": "53529445695754",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1-1_1.jpg?v=1787045343&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1-1_1.jpg?v=1787045343&width=64",
   "hex": "#E6C2AD",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1-1_1.jpg?v=1787045343&width=96",
   "poz": "50% 38%"
  },
  {
   "cod": "400",
   "nume": "Anemone",
   "eticheta": "400 Anemone",
   "price": 42.0,
   "variantId": "53529445728522",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-009.jpg?v=1787045344&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-009.jpg?v=1787045344&width=64",
   "hex": "#ABA2DD",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-009.jpg?v=1787045344&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "401",
   "nume": "Lavender",
   "eticheta": "401 Lavender",
   "price": 42.0,
   "variantId": "53529445761290",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-011.jpg?v=1787045344&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-011.jpg?v=1787045344&width=64",
   "hex": "#694C8F",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-011.jpg?v=1787045344&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "503",
   "nume": "Azure",
   "eticheta": "503 Azure",
   "price": 42.0,
   "variantId": "53529445794058",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-022.jpg?v=1787045346&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-022.jpg?v=1787045346&width=64",
   "hex": "#365C94",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-022.jpg?v=1787045346&width=96",
   "poz": "50% 38%"
  },
  {
   "cod": "505",
   "nume": "Electric Blue",
   "eticheta": "505 Electric Blue",
   "price": 42.0,
   "variantId": "53529445826826",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/FineMerinoELECTRICBLUE.jpg?v=1787045345&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/FineMerinoELECTRICBLUE.jpg?v=1787045345&width=64",
   "hex": "#0233A8",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/FineMerinoELECTRICBLUE.jpg?v=1787045345&width=96",
   "poz": "50% 38%"
  },
  {
   "cod": "506",
   "nume": "Denim",
   "eticheta": "506 Denim",
   "price": 42.0,
   "variantId": "53529445859594",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/FineMerino-DENIM.jpg?v=1787045346&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/FineMerino-DENIM.jpg?v=1787045346&width=64",
   "hex": "#1C2450",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/FineMerino-DENIM.jpg?v=1787045346&width=96",
   "poz": "50% 38%"
  },
  {
   "cod": "507",
   "nume": "Midnight",
   "eticheta": "507 Midnight",
   "price": 42.0,
   "variantId": "53525422735626",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/507_MIDNIGHT_e3374b1c-f855-4149-8236-88b1d62e265f.jpg?v=1786970785&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/507_MIDNIGHT_e3374b1c-f855-4149-8236-88b1d62e265f.jpg?v=1786970785&width=64",
   "hex": "#201B36",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/507_MIDNIGHT_e3374b1c-f855-4149-8236-88b1d62e265f.jpg?v=1786970785&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "508",
   "nume": "Slate Blue",
   "eticheta": "508 Slate Blue",
   "price": 42.0,
   "variantId": "53529445892362",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-017.jpg?v=1787045346&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-017.jpg?v=1787045346&width=64",
   "hex": "#555B7E",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-017.jpg?v=1787045346&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "513",
   "nume": "Pastel Blue",
   "eticheta": "513 Pastel Blue",
   "price": 42.0,
   "variantId": "53529445925130",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/FineMerino-PASTELBLUE.jpg?v=1787045345&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/FineMerino-PASTELBLUE.jpg?v=1787045345&width=64",
   "hex": "#A2B1DA",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/FineMerino-PASTELBLUE.jpg?v=1787045345&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "601",
   "nume": "Slate",
   "eticheta": "601 Slate",
   "price": 42.0,
   "variantId": "53525423128842",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-015_ab2a4a56-57ed-4374-96e7-3b1e140deb36.webp?v=1786970786&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-015_ab2a4a56-57ed-4374-96e7-3b1e140deb36.webp?v=1786970786&width=64",
   "hex": "#767585",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/100-240411-015_ab2a4a56-57ed-4374-96e7-3b1e140deb36.webp?v=1786970786&width=96",
   "poz": "50% 38%"
  },
  {
   "cod": "602",
   "nume": "Charcoal",
   "eticheta": "602 Charcoal",
   "price": 42.0,
   "variantId": "53525423030538",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/602_CHARCOAL_1_b0c87e6e-fc84-4613-b511-1837e97706e2.jpg?v=1786970785&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/602_CHARCOAL_1_b0c87e6e-fc84-4613-b511-1837e97706e2.jpg?v=1786970785&width=64",
   "hex": "#353241",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/602_CHARCOAL_1_b0c87e6e-fc84-4613-b511-1837e97706e2.jpg?v=1786970785&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "603",
   "nume": "Black",
   "eticheta": "603 Black",
   "price": 42.0,
   "variantId": "53525423063306",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/603_BLACK_003210ee-fba0-4096-8154-d900d10f61d1.jpg?v=1786970785&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/603_BLACK_003210ee-fba0-4096-8154-d900d10f61d1.jpg?v=1786970785&width=64",
   "hex": "#1B1523",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/603_BLACK_003210ee-fba0-4096-8154-d900d10f61d1.jpg?v=1786970785&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "604",
   "nume": "Soft Grey",
   "eticheta": "604 Soft Grey",
   "price": 42.0,
   "variantId": "53525422768394",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Screenshot2026-01-30at12.06.18_17801dd6-fce0-47d9-b138-9b161b7f8a35.png?v=1786970784&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Screenshot2026-01-30at12.06.18_17801dd6-fce0-47d9-b138-9b161b7f8a35.png?v=1786970784&width=64",
   "hex": "#A5A3A8",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/Screenshot2026-01-30at12.06.18_17801dd6-fce0-47d9-b138-9b161b7f8a35.png?v=1786970784&width=96",
   "poz": "25% 50%"
  },
  {
   "cod": "701",
   "nume": "Pistachio",
   "eticheta": "701 Pistachio",
   "price": 42.0,
   "variantId": "53525423096074",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/701_PISTACHIO_cf040839-44e2-46d0-b1df-53b9b895bcc3.jpg?v=1786970785&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/701_PISTACHIO_cf040839-44e2-46d0-b1df-53b9b895bcc3.jpg?v=1786970785&width=64",
   "hex": "#7F7718",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/701_PISTACHIO_cf040839-44e2-46d0-b1df-53b9b895bcc3.jpg?v=1786970785&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "702",
   "nume": "Olive",
   "eticheta": "702 Olive",
   "price": 42.0,
   "variantId": "53525422801162",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/10-251022-005_7c4770c4-8070-41d1-b53a-2e06342b63bc.jpg?v=1786970784&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/10-251022-005_7c4770c4-8070-41d1-b53a-2e06342b63bc.jpg?v=1786970784&width=64",
   "hex": "#8A8260",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/10-251022-005_7c4770c4-8070-41d1-b53a-2e06342b63bc.jpg?v=1786970784&width=96",
   "poz": "50% 38%"
  },
  {
   "cod": "704",
   "nume": "Limeade",
   "eticheta": "704 Limeade",
   "price": 42.0,
   "variantId": "53529445957898",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/FineMerino-LIMEADE.jpg?v=1787045346&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/FineMerino-LIMEADE.jpg?v=1787045346&width=64",
   "hex": "#CEC52B",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/FineMerino-LIMEADE.jpg?v=1787045346&width=96",
   "poz": "38% 38%"
  },
  {
   "cod": "712",
   "nume": "Spruce",
   "eticheta": "712 Spruce",
   "price": 42.0,
   "variantId": "53529445990666",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1-3_1_1c8b33c4-f051-415e-ba6e-6fade1250b9c.jpg?v=1787045346&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1-3_1_1c8b33c4-f051-415e-ba6e-6fade1250b9c.jpg?v=1787045346&width=64",
   "hex": "#637470",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1-3_1_1c8b33c4-f051-415e-ba6e-6fade1250b9c.jpg?v=1787045346&width=96",
   "poz": "50% 38%"
  },
  {
   "cod": "713",
   "nume": "Mint Glow",
   "eticheta": "713 Mint Glow",
   "price": 42.0,
   "variantId": "53529446023434",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1-2_1.jpg?v=1787045346&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1-2_1.jpg?v=1787045346&width=64",
   "hex": "#919497",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/1-2_1.jpg?v=1787045346&width=96",
   "poz": "75% 62%"
  },
  {
   "cod": "901",
   "nume": "Mulberry",
   "eticheta": "901 Mulberry",
   "price": 42.0,
   "variantId": "53525422833930",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/10-251022-002_4cb5413e-4e4e-4749-a656-74512a1528f4.jpg?v=1786970784&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/10-251022-002_4cb5413e-4e4e-4749-a656-74512a1528f4.jpg?v=1786970784&width=64",
   "hex": "#57082F",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/10-251022-002_4cb5413e-4e4e-4749-a656-74512a1528f4.jpg?v=1786970784&width=96",
   "poz": "50% 38%"
  },
  {
   "cod": "902",
   "nume": "Wine",
   "eticheta": "902 Wine",
   "price": 42.0,
   "variantId": "53525422866698",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/902_WINE_8c060eea-8f3e-4b18-a3b6-6d18b904ffab.jpg?v=1786970784&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/902_WINE_8c060eea-8f3e-4b18-a3b6-6d18b904ffab.jpg?v=1786970784&width=64",
   "hex": "#210F22",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/902_WINE_8c060eea-8f3e-4b18-a3b6-6d18b904ffab.jpg?v=1786970784&width=96",
   "poz": "50% 38%"
  }
 ],
 "kal-01-peer-gynt": [
  {
   "cod": "1001",
   "nume": "Optisk hvit",
   "eticheta": "1001 Optisk hvit",
   "price": 27.0,
   "variantId": "53525401534730",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011001_hvit_300dpi_noste_e96597a6-e788-408f-b76e-831ddc41ac88.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011001_hvit_300dpi_noste_e96597a6-e788-408f-b76e-831ddc41ac88.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011001_hvit_72dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#F0EFE9"
  },
  {
   "cod": "1002",
   "nume": "Hvit",
   "eticheta": "1002 Hvit",
   "price": 27.0,
   "variantId": "53525401567498",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011002_hvit_300dpi_noste_22ba4f9e-0fcc-4e77-b52a-87ad89355f6f.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011002_hvit_300dpi_noste_22ba4f9e-0fcc-4e77-b52a-87ad89355f6f.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011002_hvit_72dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#EFEEE7"
  },
  {
   "cod": "1012",
   "nume": "Natur",
   "eticheta": "1012 Natur",
   "price": 27.0,
   "variantId": "53525401600266",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011012_natur_300dpi_noste.jpg?v=1786970692&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011012_natur_300dpi_noste.jpg?v=1786970692&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011012_natur_72dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#ECDEC4"
  },
  {
   "cod": "1032",
   "nume": "Lys gråmelert",
   "eticheta": "1032 Lys gråmelert",
   "price": 27.0,
   "variantId": "53525401633034",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011032_lys-gramelert_300dpi_noste_422805f3-6817-4266-ab9f-960a1ff6456e.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011032_lys-gramelert_300dpi_noste_422805f3-6817-4266-ab9f-960a1ff6456e.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011032_lys-graamelert_72dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#AAA9A4"
  },
  {
   "cod": "1035",
   "nume": "Lys gråmelert m/løvfall tweed",
   "eticheta": "1035 Lys gråmelert m/løvfall tweed",
   "price": 27.0,
   "variantId": "53525401665802",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011035_lys-gramelert-lovfall-tweed_300dpi_noste_1.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011035_lys-gramelert-lovfall-tweed_300dpi_noste_1.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011035_lys-gramelert-lovfall-tweed_300dpi_close-up_3.jpg?v=1786976371&width=96",
   "hex": "#ADA79F"
  },
  {
   "cod": "1042",
   "nume": "Gråmelert",
   "eticheta": "1042 Gråmelert",
   "price": 27.0,
   "variantId": "53525401698570",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011042_gramelert_300dpi_noste.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011042_gramelert_300dpi_noste.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011042_graamelert_72dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#97958C"
  },
  {
   "cod": "1044",
   "nume": "Natur m/tutti frutti tweed",
   "eticheta": "1044 Natur m/tutti frutti tweed",
   "price": 27.0,
   "variantId": "53525401731338",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011044_natur-m-tutti-frutti-tweed_300dpi_noste.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011044_natur-m-tutti-frutti-tweed_300dpi_noste.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011044_natur-m--tutti-frutti-tweed_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#DDD1B7"
  },
  {
   "cod": "1053",
   "nume": "Mørk gråmelert",
   "eticheta": "1053 Mørk gråmelert",
   "price": 27.0,
   "variantId": "53525401764106",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011053_mork-gramelert_300dpi_noste_3c99bad4-3992-4d93-a18d-e12c930809bf.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011053_mork-gramelert_300dpi_noste_3c99bad4-3992-4d93-a18d-e12c930809bf.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011053_mork-graamelert_72dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#696966"
  },
  {
   "cod": "1088",
   "nume": "Koksmelert",
   "eticheta": "1088 Koksmelert",
   "price": 27.0,
   "variantId": "53525401796874",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011088_koksmelert_300dpi_noste_2796785d-7a37-4ce1-bb13-39961e9b3019.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011088_koksmelert_300dpi_noste_2796785d-7a37-4ce1-bb13-39961e9b3019.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011088_koksmelert_72dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#2C2C2D"
  },
  {
   "cod": "1099",
   "nume": "Svart",
   "eticheta": "1099 Svart",
   "price": 27.0,
   "variantId": "53525401829642",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011099_svart_300dpi_noste.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011099_svart_300dpi_noste.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011099_svart_72dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#1F1F1F"
  },
  {
   "cod": "1502",
   "nume": "Lys gråmelert m/blå tweed",
   "eticheta": "1502 Lys gråmelert m/blå tweed",
   "price": 27.0,
   "variantId": "53525401862410",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011502_lys-gramelert-bla-tweed_300dpi_noste_1.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011502_lys-gramelert-bla-tweed_300dpi_noste_1.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11011502_lys-gramelert-bla-tweed_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#A9ACA8"
  },
  {
   "cod": "2152",
   "nume": "Vintage gold",
   "eticheta": "2152 Vintage gold",
   "price": 27.0,
   "variantId": "53525401895178",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012152_vintage-gold_300dpi_noste.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012152_vintage-gold_300dpi_noste.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012152_vintage-gold_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#96703E"
  },
  {
   "cod": "2321",
   "nume": "Marsipan",
   "eticheta": "2321 Marsipan",
   "price": 27.0,
   "variantId": "53525401927946",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012321_marsipan_300dpi_noste.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012321_marsipan_300dpi_noste.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012321_marsipan_72dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#D1BEAE"
  },
  {
   "cod": "2523",
   "nume": "Natur tweed",
   "eticheta": "2523 Natur tweed",
   "price": 27.0,
   "variantId": "53525401960714",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012523_natur-tweed_300dpi_noste_1.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012523_natur-tweed_300dpi_noste_1.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012523_natur-tweed_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#E5D8C2"
  },
  {
   "cod": "2564",
   "nume": "Gyllenbrun",
   "eticheta": "2564 Gyllenbrun",
   "price": 27.0,
   "variantId": "53525401993482",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012564_gyllenbrun_300dpi_noste.jpg?v=1786970694&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012564_gyllenbrun_300dpi_noste.jpg?v=1786970694&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012564_gyllenbrun_72dpi_close-up_1.jpg?v=1786976371&width=96",
   "hex": "#703F14"
  },
  {
   "cod": "2641",
   "nume": "Naturmelert",
   "eticheta": "2641 Naturmelert",
   "price": 27.0,
   "variantId": "53525402026250",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012641_naturmelert_300dpi_noste_6af94384-84d9-46b4-af0a-bae0f6bb5430.jpg?v=1786970694&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012641_naturmelert_300dpi_noste_6af94384-84d9-46b4-af0a-bae0f6bb5430.jpg?v=1786970694&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012641_naturmelert_300dpi_close-up.jpg?v=1786976372&width=96",
   "hex": "#DACEBB"
  },
  {
   "cod": "2650",
   "nume": "Gråbeige melert",
   "eticheta": "2650 Gråbeige melert",
   "price": 27.0,
   "variantId": "53525402059018",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012650_grabeige-melert_300dpi_noste_3219c64d-8aa1-4747-9420-863fa7bed7cf.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012650_grabeige-melert_300dpi_noste_3219c64d-8aa1-4747-9420-863fa7bed7cf.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012650_graabeige-melert_72dpi_close-up.jpg?v=1786976372&width=96",
   "hex": "#AD9F96"
  },
  {
   "cod": "2652",
   "nume": "Mellombrun melert",
   "eticheta": "2652 Mellombrun melert",
   "price": 27.0,
   "variantId": "53525402091786",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012652_mellombrun-melert_300dpi_noste_a909dcfa-797f-4386-82e8-b5c54b3eec19.jpg?v=1786970694&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012652_mellombrun-melert_300dpi_noste_a909dcfa-797f-4386-82e8-b5c54b3eec19.jpg?v=1786970694&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012652_mellombrun-melert_72dpi_close-up.jpg?v=1786976372&width=96",
   "hex": "#74665F"
  },
  {
   "cod": "2720",
   "nume": "Marsipan m/tutti frutti tweed",
   "eticheta": "2720 Marsipan m/tutti frutti tweed",
   "price": 27.0,
   "variantId": "53525402124554",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012720_marsipan-tutti-frutti-tweed_300dpi_noste_1.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012720_marsipan-tutti-frutti-tweed_300dpi_noste_1.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012720_marsipan-tutti-frutti-tweed_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#D3C0AE"
  },
  {
   "cod": "2730",
   "nume": "Beigemelert m/natur tweed",
   "eticheta": "2730 Beigemelert m/natur tweed",
   "price": 27.0,
   "variantId": "53525402157322",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012730_beigemelert-natur-tweed_300dpi_noste_2.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012730_beigemelert-natur-tweed_300dpi_noste_2.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012730_beigemelert-natur-tweed_300dpi_close-up_1.jpg?v=1786976371&width=96",
   "hex": "#CBB8A6"
  },
  {
   "cod": "2745",
   "nume": "Cognac",
   "eticheta": "2745 Cognac",
   "price": 27.0,
   "variantId": "53525402190090",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012745_cognac_300dpi_noste_1.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012745_cognac_300dpi_noste_1.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11012745_cognac_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#B55820"
  },
  {
   "cod": "3021",
   "nume": "Lys beigemelert",
   "eticheta": "3021 Lys beigemelert",
   "price": 27.0,
   "variantId": "53525402222858",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013021_lys-beigemelert_300dpi_noste_573063de-66fe-4b99-be8f-65dbfcba65c6.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013021_lys-beigemelert_300dpi_noste_573063de-66fe-4b99-be8f-65dbfcba65c6.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013021_lys-beige-melert_72dpi_close-up_1.jpg?v=1786976371&width=96",
   "hex": "#C8B5A5"
  },
  {
   "cod": "3082",
   "nume": "Mørk brun",
   "eticheta": "3082 Mørk brun",
   "price": 27.0,
   "variantId": "53525402255626",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013082_brun_300dpi_noste_acb0e5b7-c306-4523-aeef-8efe7e619d26.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013082_brun_300dpi_noste_acb0e5b7-c306-4523-aeef-8efe7e619d26.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013082_brun_72dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#453332"
  },
  {
   "cod": "3085",
   "nume": "Mørk brun m/natur tweed",
   "eticheta": "3085 Mørk brun m/natur tweed",
   "price": 27.0,
   "variantId": "53525402288394",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013085_brun-tweed_300dpi_noste.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013085_brun-tweed_300dpi_noste.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013085_brun-tweed_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#493833"
  },
  {
   "cod": "3161",
   "nume": "Eikenøtt",
   "eticheta": "3161 Eikenøtt",
   "price": 27.0,
   "variantId": "53525402321162",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013161_eikenott_300dpi_noste.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013161_eikenott_300dpi_noste.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013161_eikenott_72dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#71574E"
  },
  {
   "cod": "3342",
   "nume": "Mocha mousse",
   "eticheta": "3342 Mocha mousse",
   "price": 27.0,
   "variantId": "53525402353930",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013342_mocha-mousse_300dpi_noste.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013342_mocha-mousse_300dpi_noste.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013342_mocha-mousse_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#9F6D56"
  },
  {
   "cod": "3800",
   "nume": "Bristol black",
   "eticheta": "3800 Bristol black",
   "price": 27.0,
   "variantId": "53525402386698",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013800_bristol-black_300dpi_noste_2.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013800_bristol-black_300dpi_noste_2.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013800_bristol-black_300dpi_close-up_1.jpg?v=1786976371&width=96",
   "hex": "#373233"
  },
  {
   "cod": "3819",
   "nume": "Spicy orange",
   "eticheta": "3819 Spicy orange",
   "price": 27.0,
   "variantId": "53525402419466",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013819_spicy-orange_300dpi_noste_1.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013819_spicy-orange_300dpi_noste_1.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013819_spicy-orange_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#EF411D"
  },
  {
   "cod": "3854",
   "nume": "Spiced apple",
   "eticheta": "3854 Spiced apple",
   "price": 27.0,
   "variantId": "53525402452234",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013854_spiced-apple_300dpi_noste_2.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013854_spiced-apple_300dpi_noste_2.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11013854_spiced-apple_300dpi_close-up_1.jpg?v=1786976371&width=96",
   "hex": "#914543"
  },
  {
   "cod": "4018",
   "nume": "Scarlet red",
   "eticheta": "4018 Scarlet red",
   "price": 27.0,
   "variantId": "53525402485002",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11014018_scarlet-red_300dpi_noste_1.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11014018_scarlet-red_300dpi_noste_1.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11014018_scarlet-red_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#CB1921"
  },
  {
   "cod": "4202",
   "nume": "Lotus",
   "eticheta": "4202 Lotus",
   "price": 27.0,
   "variantId": "53525402517770",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11014202_lotus_300dpi_noste.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11014202_lotus_300dpi_noste.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11014202_lotus_300dpi_close-up.jpg?v=1786976372&width=96",
   "hex": "#E8C7C4"
  },
  {
   "cod": "4228",
   "nume": "Rød",
   "eticheta": "4228 Rød",
   "price": 27.0,
   "variantId": "53525402550538",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11014228_rod_300dpi_noste_1.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11014228_rod_300dpi_noste_1.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11014228_rod_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#910325"
  },
  {
   "cod": "4255",
   "nume": "Rumba red",
   "eticheta": "4255 Rumba red",
   "price": 27.0,
   "variantId": "53525402583306",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11014255_rumba-red_300dpi_noste_1.jpg?v=1786970694&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11014255_rumba-red_300dpi_noste_1.jpg?v=1786970694&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11014255_rumba-red_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#92183C"
  },
  {
   "cod": "4363",
   "nume": "Vinrød",
   "eticheta": "4363 Vinrød",
   "price": 27.0,
   "variantId": "53525402616074",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11014363_vinr_d_300dpi_noste_1.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11014363_vinr_d_300dpi_noste_1.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11014363_vinrod_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#683748"
  },
  {
   "cod": "4626",
   "nume": "Shocking pink",
   "eticheta": "4626 Shocking pink",
   "price": 27.0,
   "variantId": "53525402648842",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11014626_shocking-pink_300dpi_noste_1.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11014626_shocking-pink_300dpi_noste_1.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11014626_shocking-pink_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#F59BC2"
  },
  {
   "cod": "4672",
   "nume": "Bjørnebærsaft",
   "eticheta": "4672 Bjørnebærsaft",
   "price": 27.0,
   "variantId": "53525402681610",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11014672_bjornebaersaft_300dpi_noste_1.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11014672_bjornebaersaft_300dpi_noste_1.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11014672_bjornebaersaft_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#552E4C"
  },
  {
   "cod": "5575",
   "nume": "Marine",
   "eticheta": "5575 Marine",
   "price": 27.0,
   "variantId": "53525402714378",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11015575_marine_300dpi_noste.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11015575_marine_300dpi_noste.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11015575_marine_72dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#252742"
  },
  {
   "cod": "5585",
   "nume": "Marineblå m/natur tweed",
   "eticheta": "5585 Marineblå m/natur tweed",
   "price": 27.0,
   "variantId": "53525402747146",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11015585_marinebla-tweed_300dpi_noste.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11015585_marinebla-tweed_300dpi_noste.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11015585_marinebla-tweed_300dpi_close-up.jpg?v=1786976372&width=96",
   "hex": "#202438"
  },
  {
   "cod": "5811",
   "nume": "Arctic ice",
   "eticheta": "5811 Arctic ice",
   "price": 27.0,
   "variantId": "53525402779914",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11015811_arctic-ice_300dpi_noste-3_1.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11015811_arctic-ice_300dpi_noste-3_1.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11015811_arctic-ice_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#DAE3E5"
  },
  {
   "cod": "5845",
   "nume": "Dazzling blue",
   "eticheta": "5845 Dazzling blue",
   "price": 27.0,
   "variantId": "53525402812682",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11015845_dazzling-blue_300dpi_noste-2_1.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11015845_dazzling-blue_300dpi_noste-2_1.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11015845_dazzling-blue_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#264F9B"
  },
  {
   "cod": "6044",
   "nume": "Regatta blå",
   "eticheta": "6044 Regatta blå",
   "price": 27.0,
   "variantId": "53525402845450",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11016044_ragatta-blaa_300dpi_noste_1.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11016044_ragatta-blaa_300dpi_noste_1.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11016044_ragatta-blaa_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#5281B0"
  },
  {
   "cod": "6046",
   "nume": "Jolly blue",
   "eticheta": "6046 Jolly blue",
   "price": 27.0,
   "variantId": "53525402878218",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11016046_jolly-blue_300dpi_noste_1.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11016046_jolly-blue_300dpi_noste_1.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11016046_jolly-blue_300dpi_close-up_1.jpg?v=1786976371&width=96",
   "hex": "#054C8F"
  },
  {
   "cod": "6062",
   "nume": "Mørk blå",
   "eticheta": "6062 Mørk blå",
   "price": 27.0,
   "variantId": "53525402910986",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11016062_mork-bla_300dpi_noste_124ba77f-0dc4-443f-9c7b-3f406459adf7.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11016062_mork-bla_300dpi_noste_124ba77f-0dc4-443f-9c7b-3f406459adf7.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11016062_mork-blaa_72dpi_close-up_1.jpg?v=1786976371&width=96",
   "hex": "#19334D"
  },
  {
   "cod": "6324",
   "nume": "Blåmelert",
   "eticheta": "6324 Blåmelert",
   "price": 27.0,
   "variantId": "53525402943754",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11016324_blamelert_300dpi_noste.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11016324_blamelert_300dpi_noste.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11016324_blaamelert_72dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#7089A2"
  },
  {
   "cod": "6364",
   "nume": "Mørk blå",
   "eticheta": "6364 Mørk blå",
   "price": 27.0,
   "variantId": "53525402976522",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11016364_mork-bla_300dpi_noste.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11016364_mork-bla_300dpi_noste.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11016364_mork-blaa_72dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#2F3455"
  },
  {
   "cod": "6572",
   "nume": "Mørk blå",
   "eticheta": "6572 Mørk blå",
   "price": 27.0,
   "variantId": "53525403009290",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11016572_mork-bla_300dpi_noste.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11016572_mork-bla_300dpi_noste.jpg?v=1786970693&width=64",
   "hex": "#475C6A",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11016572_mork-bla_300dpi_noste.jpg?v=1786970693&width=96",
   "poz": "0% 50%"
  },
  {
   "cod": "6581",
   "nume": "Mørk gråblå",
   "eticheta": "6581 Mørk gråblå",
   "price": 27.0,
   "variantId": "53525403042058",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11016581_mork-grabla_300dpi_noste.jpg?v=1786970694&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11016581_mork-grabla_300dpi_noste.jpg?v=1786970694&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11016581_mork-grabla_72dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#32303C"
  },
  {
   "cod": "7281",
   "nume": "Dyp petrol",
   "eticheta": "7281 Dyp petrol",
   "price": 27.0,
   "variantId": "53525403074826",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11017281_dyp-petrol_300dpi_noste_1.jpg?v=1786970694&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11017281_dyp-petrol_300dpi_noste_1.jpg?v=1786970694&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11017281_dyp-petrol_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#244143"
  },
  {
   "cod": "7772",
   "nume": "Rain forest",
   "eticheta": "7772 Rain forest",
   "price": 27.0,
   "variantId": "53525403107594",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11017772_rainforest_300dpi_noste.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11017772_rainforest_300dpi_noste.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11017772_rainforest_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#1D4B3F"
  },
  {
   "cod": "7911",
   "nume": "Mint",
   "eticheta": "7911 Mint",
   "price": 27.0,
   "variantId": "53525403140362",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11017911_mint_300dpi_noste.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11017911_mint_300dpi_noste.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11017911_mint_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#E3EBE2"
  },
  {
   "cod": "8051",
   "nume": "Eukalyptus",
   "eticheta": "8051 Eukalyptus",
   "price": 27.0,
   "variantId": "53525403173130",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11018051_eukalyptus_300dpi_noste_59e5fb4d-1246-48ef-8894-cd9a804165ca.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11018051_eukalyptus_300dpi_noste_59e5fb4d-1246-48ef-8894-cd9a804165ca.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11018051_eukalyptus_72dpi_close-up_2.jpg?v=1786976371&width=96",
   "hex": "#7E8D83"
  },
  {
   "cod": "8082",
   "nume": "Skoggrønn",
   "eticheta": "8082 Skoggrønn",
   "price": 27.0,
   "variantId": "53525403205898",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11018082_skoggronn_300dpi_noste_de55cb40-1c3e-4b80-bb9d-12e7ebe5dd2b.jpg?v=1786970694&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11018082_skoggronn_300dpi_noste_de55cb40-1c3e-4b80-bb9d-12e7ebe5dd2b.jpg?v=1786970694&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11018082_skoggronn_72dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#304633"
  },
  {
   "cod": "8085",
   "nume": "Skoggrønn m/natur tweed",
   "eticheta": "8085 Skoggrønn m/natur tweed",
   "price": 27.0,
   "variantId": "53525403238666",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11018085_gronn-tweed_300dpi_noste.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11018085_gronn-tweed_300dpi_noste.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11018085_gronn-tweed_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#325134"
  },
  {
   "cod": "8236",
   "nume": "Jelly bean green",
   "eticheta": "8236 Jelly bean green",
   "price": 27.0,
   "variantId": "53525403271434",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11018236_jelly-bean-green_300dpi_noste_1_1.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11018236_jelly-bean-green_300dpi_noste_1_1.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11018236_jelly-bean-green_300dpi_close-up_2.jpg?v=1786976372&width=96",
   "hex": "#17935A"
  },
  {
   "cod": "8733",
   "nume": "Spring green",
   "eticheta": "8733 Spring green",
   "price": 27.0,
   "variantId": "53525403304202",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11018733_spring-green_300dpi_noste_1.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11018733_spring-green_300dpi_noste_1.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11018733_spring-green_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#A0BC88"
  },
  {
   "cod": "8753",
   "nume": "Vineyard green",
   "eticheta": "8753 Vineyard green",
   "price": 27.0,
   "variantId": "53525403336970",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11018753_vineyard-green_300dpi_noste_0791fc09-4c3f-48aa-b224-a85352258d81.jpg?v=1786970694&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11018753_vineyard-green_300dpi_noste_0791fc09-4c3f-48aa-b224-a85352258d81.jpg?v=1786970694&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11018753_vineyard-green_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#6E8A5A"
  },
  {
   "cod": "9080",
   "nume": "Urban chic",
   "eticheta": "9080 Urban chic",
   "price": 27.0,
   "variantId": "53525403369738",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11019080_urban-chic_300dpi_noste_2.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11019080_urban-chic_300dpi_noste_2.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11019080_urban-chic_300dpi_close-up_1.jpg?v=1786976371&width=96",
   "hex": "#49504E"
  },
  {
   "cod": "9572",
   "nume": "Mørk grønnmelert",
   "eticheta": "9572 Mørk grønnmelert",
   "price": 27.0,
   "variantId": "53525403402506",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11019572_mork-gronnmelert_300dpi_noste_2cc1970e-ee69-4a24-94c5-520057bc1157.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11019572_mork-gronnmelert_300dpi_noste_2cc1970e-ee69-4a24-94c5-520057bc1157.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11019572_mork-gronnmelert_72dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#515741"
  },
  {
   "cod": "9602",
   "nume": "Lemonade",
   "eticheta": "9602 Lemonade",
   "price": 27.0,
   "variantId": "53525403435274",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11019602_lemonade_300dpi_close-up.jpg?v=1786970693&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11019602_lemonade_300dpi_close-up.jpg?v=1786970693&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11019602_lemonade_300dpi_close-up_33ae6b66-1740-4594-9c34-371fa2e207dc.jpg?v=1786976372&width=96",
   "hex": "#F1E6A7"
  },
  {
   "cod": "9873",
   "nume": "Dark olive",
   "eticheta": "9873 Dark olive",
   "price": 27.0,
   "variantId": "53525403468042",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11019873_dark-olive_300dpi_noste_1.jpg?v=1786970694&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11019873_dark-olive_300dpi_noste_1.jpg?v=1786970694&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11019873_dark-olive_300dpi_close-up.jpg?v=1786976371&width=96",
   "hex": "#6F5B3B"
  }
 ],
 "kal-01-petiteknit-peer-gynt": [
  {
   "cod": "1021",
   "nume": "Ash Melange",
   "eticheta": "1021 Ash Melange",
   "price": 27.0,
   "variantId": "53525361000714",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11031021_lys-graa-melange_300dpi_noste.jpg?v=1786970107&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11031021_lys-graa-melange_300dpi_noste.jpg?v=1786970107&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11031021_lys-graa-melange_300dpi_close-up.jpg?v=1786976585&width=96",
   "hex": "#E4E2E0"
  },
  {
   "cod": "1065",
   "nume": "Charcoal Melange",
   "eticheta": "1065 Charcoal Melange",
   "price": 27.0,
   "variantId": "53525361033482",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/10031065_koksgra-melange_300dpi_noste.jpg?v=1786970107&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/10031065_koksgra-melange_300dpi_noste.jpg?v=1786970107&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/10031065_koksgra-melange_300dpi_close-up.jpg?v=1786976585&width=96",
   "hex": "#484746"
  },
  {
   "cod": "2381",
   "nume": "Coffee Melange",
   "eticheta": "2381 Coffee Melange",
   "price": 27.0,
   "variantId": "53525361066250",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11032381_coffee-melange_300dpi_noste.jpg?v=1786970107&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11032381_coffee-melange_300dpi_noste.jpg?v=1786970107&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11032381_coffee-melange_300dpi_close-up.jpg?v=1786976585&width=96",
   "hex": "#39312B"
  },
  {
   "cod": "2511",
   "nume": "Almond",
   "eticheta": "2511 Almond",
   "price": 27.0,
   "variantId": "53525361099018",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11032511_almond_300dpi_noste_1_e2870a51-fa42-40ca-9691-821df8d3fcb3.jpg?v=1786970107&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11032511_almond_300dpi_noste_1_e2870a51-fa42-40ca-9691-821df8d3fcb3.jpg?v=1786970107&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11032511_almond_300dpi_close-up_1.jpg?v=1786976585&width=96",
   "hex": "#DBCCBB"
  },
  {
   "cod": "3070",
   "nume": "Muskat Melange",
   "eticheta": "3070 Muskat Melange",
   "price": 27.0,
   "variantId": "53525361131786",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/10033070_muskat-melange_300dpi_noste_1_1.jpg?v=1786970107&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/10033070_muskat-melange_300dpi_noste_1_1.jpg?v=1786970107&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/10033070_muskat-melange_300dpi_close-up_1_1.jpg?v=1786976585&width=96",
   "hex": "#6A5547"
  },
  {
   "cod": "3091",
   "nume": "Cacao Nibs",
   "eticheta": "3091 Cacao Nibs",
   "price": 27.0,
   "variantId": "53525361164554",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11033091_cacao-nibs_300dpi_noste_1.jpg?v=1786970107&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11033091_cacao-nibs_300dpi_noste_1.jpg?v=1786970107&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11033091_cacao-nibs_300dpi_close-up_1.jpg?v=1786976585&width=96",
   "hex": "#3A2A27"
  },
  {
   "cod": "3891",
   "nume": "Dusty Noir",
   "eticheta": "3891 Dusty Noir",
   "price": 27.0,
   "variantId": "53525361197322",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11033891_dusty-noir_300dpi_noste.jpg?v=1786970107&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11033891_dusty-noir_300dpi_noste.jpg?v=1786970107&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11033891_dusty-noir_300dpi_close-up.jpg?v=1786976585&width=96",
   "hex": "#33322F"
  },
  {
   "cod": "5012",
   "nume": "Perfect Purple",
   "eticheta": "5012 Perfect Purple",
   "price": 27.0,
   "variantId": "53525361230090",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11035012_perfect-purple_300dpi_noste.jpg?v=1786970107&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11035012_perfect-purple_300dpi_noste.jpg?v=1786970107&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11035012_perfect-purple_300dpi_close-up.jpg?v=1786976585&width=96",
   "hex": "#B6B2D1"
  },
  {
   "cod": "6082",
   "nume": "Thunderstorm",
   "eticheta": "6082 Thunderstorm",
   "price": 27.0,
   "variantId": "53525361262858",
   "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11036082_thunderstorm_300dpi_noste.jpg?v=1786970107&width=500",
   "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11036082_thunderstorm_300dpi_noste.jpg?v=1786970107&width=64",
   "swatch": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/11036082_thunderstorm_300dpi_close-up.jpg?v=1786976585&width=96",
   "hex": "#2A3840"
  }
 ]
};

/* Tiparele: fotografiile şi variant id-ul produsului de 0 lei. */
const TIPARE = {
 "kal-01-tipar-eva": {
  "poze": [
   {
    "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/evamallorca1_ea6fdb82-e2b7-492a-9a74-b44e98492a07.jpg?v=1786972569&width=900",
    "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/evamallorca1_ea6fdb82-e2b7-492a-9a74-b44e98492a07.jpg?v=1786972569&width=400",
    "principala": true
   },
   {
    "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/evacardiganhvidvaeg3_dea138a8-9cf9-42e5-ade1-bab06c3c86c9.jpg?v=1786972569&width=900",
    "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/evacardiganhvidvaeg3_dea138a8-9cf9-42e5-ade1-bab06c3c86c9.jpg?v=1786972569&width=400",
    "principala": false
   },
   {
    "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/evamalloca2.jpg?v=1786972569&width=900",
    "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/evamalloca2.jpg?v=1786972569&width=400",
    "principala": false
   },
   {
    "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/evaogflorenceforancapo6.jpg?v=1786972569&width=900",
    "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/evaogflorenceforancapo6.jpg?v=1786972569&width=400",
    "principala": false
   },
   {
    "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/evaogflorenceforancapo9.jpg?v=1786972569&width=900",
    "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/evaogflorenceforancapo9.jpg?v=1786972569&width=400",
    "principala": false
   }
  ],
  "variantId": "53525361426698",
  "price": 53.0
 },
 "kal-01-tipar-chestnut": {
  "poze": [
   {
    "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/chestnutsweaterCacaoNibs.jpg?v=1786972565&width=900",
    "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/chestnutsweaterCacaoNibs.jpg?v=1786972565&width=400",
    "principala": true
   },
   {
    "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/chestnutpabaenk.jpg?v=1786972565&width=900",
    "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/chestnutpabaenk.jpg?v=1786972565&width=400",
    "principala": false
   },
   {
    "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/chestnutidetgodekryds.jpg?v=1786972565&width=900",
    "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/chestnutidetgodekryds.jpg?v=1786972565&width=400",
    "principala": false
   },
   {
    "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/chestnutsweaterpeergynt6_16122e12-81a5-40c5-8f69-33394db6d210.jpg?v=1786972565&width=900",
    "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/chestnutsweaterpeergynt6_16122e12-81a5-40c5-8f69-33394db6d210.jpg?v=1786972565&width=400",
    "principala": false
   },
   {
    "img": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/chestnutpeergynt_3730_e5bbd335-ce49-406e-9e3e-c5e536000e0d.jpg?v=1786972565&width=900",
    "thumb": "https://cdn.shopify.com/s/files/1/0897/7658/7018/files/chestnutpeergynt_3730_e5bbd335-ce49-406e-9e3e-c5e536000e0d.jpg?v=1786972565&width=400",
    "principala": false
   }
  ],
  "variantId": "53525361361162",
  "price": 53.0
 }
};

/* ═══════════════════════════════════════════════════════════════════════════
   DATE — Calculator KAL
   ───────────────────────────────────────────────────────────────────────────
   CE E REAL, din 17.08:
     · culorile, pozele, prețurile și variant id-urile → `culori.js`, GENERAT din
       colecția `kal-fire` din Shopify cu `python3 _din-shopify.py`. Nu se mai
       scriu de mână și nu se editează aici.
     · specificațiile fizice ale firelor (metraj, gramaj, andrele, tensiune,
       compoziție) → mai jos, în `YARNS`. Nu stau pe produs în Shopify, deci
       ăsta e singurul lor loc. ⚠️ La un fir nou se completează AICI, altfel
       calculul iese greșit chiar dacă produsul există.
     · cele două tipare, cu tensiunea, andrelele, mărimile, bustul finit și
       tabelul de metraj → `PATTERNS`, verificate pe petiteknit.com.
   ÎNCĂ DE TEST: organizatorii, datele ediției, textele de landing page.

   La trecerea în secțiune Liquid:
     · KAL      → setări de secțiune
     · CULORI   → generat de Liquid din colecția `kal-fire`, cu aceeași formă:
                  variantId din variantă, img din imaginea variantei
     · YARNS    → rămâne în fișier (specificații), legat prin `handle`
     · PATTERNS → colecția `kal-tipare` + tabelul de metraj

   ⚠️ Cardurile REALE nu se desenează de mână. În Liquid se folosește componenta
   nativă a temei (`content_for 'block', type: '_product-card'`), exact ca în
   calculatorul de metraj, ca să arate identic cu pagina de colecție.
   Aici e doar aproximarea ei, ca să validăm fluxul și densitatea de informație.
   ═══════════════════════════════════════════════════════════════════════════ */

const KAL = {
  nume: 'Nara KAL 2026',
  /* Termenul de închidere NU se mai anunţă (decis 31.08.2026). Ediţia s-a închis pe
     30 august cu oferta ei, tiparul gratuit şi 10% la fire; ce a rămas deschis e coada,
     la preţ întreg, până pleacă efectiv comanda la furnizor. O coadă nu are termen de
     pus în pagină, aşa că şirul gol stinge peste tot rândul „Se închid comenzile":
     din datele din hero, din fraza de final şi din bara lipită jos.
     ⚠️ Scrie o dată aici (sau în setarea de secţiune „Se închid comenzile") şi termenul
     reapare singur în toate cele trei locuri. Aşa se deschide ediţia următoare. */
  inchidereComenzi: '',
  livrare: '25 septembrie 2026',
  startTricotat: '28 septembrie 2026',
  /* Adresele celor două pagini de pe magazin. Stau aici, nu în HTML, ca să existe
     un singur loc de schimbat şi ca în Liquid să devină setări de secţiune. */
  urlLanding: '/pages/kal',
  urlCalculator: '/pages/kal-calculator',

  /* Heroul poartă exact ce scrie pe coverul de Instagram: numele celor două tipare
     şi designerul, nu un slogan. `hero.titlu` se rupe pe rânduri unde e scris `|`. */
  hero: {
    titlu: 'Chestnut Sweater sau|Eva Cardigan',
    designer: 'Petite Knit',
    subsol: 'naraknits.com/kal',
  },

  /* Reducerea ediţiei, ca fracţie. ⚠️ INVARIANT: aici e doar AFIŞAREA. Banii îi taie
     discountul automat din Shopify, „KAL 01 · fire −10%", ţintit pe colecţia `kal-fire`.
     Cele două trebuie pornite şi oprite ÎMPREUNĂ: dacă rămâne doar afişarea, calculatorul
     arată un preţ mai mic decât cel încasat la checkout, adică exact greşeala care naşte
     reclamaţii. Zero aici stinge afişarea peste tot.
     ⚠️ STINSĂ pe 31.08.2026. Discountul automat a expirat singur pe 30.08 la 21:00 UTC,
     iar afişarea a mai promis 10% câteva ore după el. Dacă vreodată se reaprinde, se
     aprind AMÂNDOUĂ în aceeaşi mişcare, plus bagdeul scris de mână din cele trei fişiere
     de temă: snippets/price.liquid, blocks/_product-card-gallery.liquid,
     sections/nara-collection-grid.liquid. */
  reducere: 0,

  rezervaImplicita: 0.10,
  /* Tensiunile pe care le poate alege userul la pasul 4, ochiuri pe 10 cm.
     ⚠️ Intervalul trebuie să acopere tensiunea FIECĂRUI fir din ediţie, altfel firul
     care cade în afară nu se poate reprezenta: acum toate sunt 20, în afară de Como
     cu 22. Un fir cardat, gen Atlas cu 18, ar cere lărgirea listei. */
  tensiuni: [19, 20, 21, 22],
  /* Câte buline se văd înainte de „+N". Cu două carduri pe rând încap toate
     nuanţele la 6 din 8 fire; doar Peer Gynt (60) și Como (58) mai au buton.
     Pe telefon cardul e de 163 px, deci acolo se arată mai puţine. */
  swatchuriVizibile: 36,
  swatchuriVizibileMobil: 12,

  /* „Fire exclusive": de când culorile vin din produsele de Shopify, exclusivitatea
     NU se mai filtrează în cod. Se decide alegând ce variante rămân pe produsul de
     KAL: ce e în produs se vede, ce ștergi din admin dispare și de aici. Vechiul
     flag `doarExclusive` a fost scos ca să nu existe două locuri care decid asta. */

  /* ⭐ TOT ce se vinde în KAL e pe PRECOMANDĂ, chiar dacă nuanţa există în stoc
     (decis 17.08). Produsele de KAL sunt separate de cele din catalog și nu se
     scad din stocul magazinului: `inventoryPolicy: CONTINUE` pe TOATE variantele,
     fără excepţia „pe asta o am, ţi-o trimit acum". Coletul pleacă o singură dată,
     la data de livrare, fiindcă oricum aşteaptă tiparul leaflet. */
  precomandaTotala: true,
  precomandaNota: 'Produsele se livrează împreună, la aceeași dată.',

  /* ── Conținut de landing page (tot de test) ──────────────────────────── */
  comunitate: 'Grup privat pe WhatsApp',
  comunitateNota: 'Primești invitația în emailul de confirmare a comenzii.',

  /* Pașii de pe landing page. Termenele stau pe pași, acolo unde omul înțelege
     oricum ce se întâmplă. `cheie` = termen care nu se mișcă, se scrie în magenta. */
  pasi: [
    { data:'Acum', cheie:true, titlu:'Alegi tiparul și firul',
      text:'Calculatorul estimează necesarul de fire pe mărimea și pe tensiunea ta, și include automat o rezervă de 10%. Le pui în coș de acolo. Precomanda rămâne deschisă până pleacă efectiv comanda la furnizor.' },
    { data:'Până pe 25 septembrie', cheie:true, titlu:'Primești coletul',
      text:'Firele și tiparul leaflet, tipărit, în același colet.' },
    { data:'28 septembrie', cheie:true, titlu:'Începem toate odată',
      text:'Prima săptămână e pentru mostra de tensiune, nu pentru tricotat.' },
    /* `comunitate:true` scoate sub text rândul cu grupul. Enumerarea etapelor a fost
       SCOASĂ pe 18.08; lista `etape` de mai jos a rămas, nefolosită, ca să se poată
       aduce înapoi fără să o rescriem. */
    { data:'Octombrie și noiembrie', cheie:false, titlu:'Ne vedem în grup',
      text:'Întrebări, poze și ajutor la pașii grei.',
      comunitate:true },
  ],

  // Etapele din timpul KAL. `scurt` intră în enumerarea de la pasul 4.
  etape: [
    { s:'Săptămâna 1', scurt:'mostra', t:'Mostra de tensiune și alegerea mărimii' },
    { s:'Săptămâna 2', scurt:'platca', t:'Montarea și platca' },
    { s:'Săptămâna 3', scurt:'corpul', t:'Corpul' },
    { s:'Săptămâna 4', scurt:'mânecile', t:'Mânecile și bordurile' },
    { s:'Săptămâna 5', scurt:'finisajele', t:'Finisaje, blocare și fotografii' },
  ],

  // `initiale` țin locul pozei în cercurile din header, până vin pozele reale
  organizatori: [
    { nume:'Mădălina', initiale:'M', rol:'Gazdă KAL',        bio:'Două rânduri de test despre cine e și ce face în KAL.',
      poza:'https://cdn.shopify.com/s/files/1/0897/7658/7018/files/kal-gazda-madalina.jpg?v=1787225309' },
    { nume:'Corina',   initiale:'C', rol:'Ambasadoare Nara', bio:'Două rânduri de test. Răspunde la întrebări în grup.',
      poza:'https://cdn.shopify.com/s/files/1/0897/7658/7018/files/kal-gazda-corina.jpg?v=1787062440' },
    { nume:'Carla',    initiale:'C', rol:'Ambasadoare Nara', bio:'Două rânduri de test. Ține etapa de finisaje.',
      poza:'https://cdn.shopify.com/s/files/1/0897/7658/7018/files/kal-gazda-carla.jpg?v=1787062443' },
  ],

  // Stickerele albe rotite de pe poză, ca în grafica de post
  /* ⚠️ Stickerele promit, deci nu pot spune decât ce e adevărat ACUM. Erau
     „10% reducere la fire" şi „Tipar gratuit", amândouă moarte odată cu ediţia pe
     30.08.2026. Ce a rămas adevărat e că precomanda merge şi că nuanţele sunt ale
     ediţiei, deci exact atât scriu. */
  stickere: ['Precomandă deschisă', 'Culori exclusive'],
  editie: 'KAL · Ediția 01',
  // acelaşi sticker alb, pus pe fotografia fiecărui tipar
  stickerTipar: 'Leaflet tipărit',

  faq: [
    { i:'Cum mă înscriu la KAL?',
      /* Orice comandă legată de KAL înscrie, inclusiv doar tiparul de 53 lei: altfel
         politica „poţi participa cu firele tale" nu are drum spre grup. ⚠️ Emailul de
         confirmare trebuie să trimită invitaţia şi pe comenzile care conţin DOAR
         tiparul, nu doar pe pachetele cu fire. Pentru cine ia tiparul direct de la
         PetiteKnit, uşa e pagina de contact. */
      r:'Nu există formular de înscriere. Orice comandă pentru KAL e înscrierea, fie pachetul cu fire, fie doar tiparul: în emailul de confirmare primești invitația în grup și calendarul pe etape. Dacă tricotezi cu firele tale și ai tiparul de la PetiteKnit, scrie-ne prin pagina de contact și te adăugăm noi în grup.' },
    { i:'Trebuie să cumpăr firele de la voi?',
      /* Formularea din recenzia din 19.08, mesajul întreg. Coada lui, „Aici ai linkul
         pentru KAL", e conversaţie de chat, nu text de FAQ, şi nu intră. */
      r:'Nu. Poți folosi fire pe care le ai deja acasă, iar tiparul îl poți achiziționa separat, de pe site-ul nostru sau de pe site-ul PetiteKnit. Dacă vrei firele ediției, calculatorul îți spune exact câte gheme îți trebuie pe mărimea ta.' },
    { i:'De ce se livrează abia peste o lună?',
      r:'Firele ediției nu le ținem pe stoc. Le comandăm la furnizor după ce se strâng precomenzile, în funcție de cât s-a vândut, iar tiparele vin tipărite de la PetiteKnit. Toată ediția pleacă la aceeași dată, chiar dacă o nuanță s-ar întâmpla să fie în stoc: coletul așteaptă oricum tiparul leaflet.' },
    { i:'Sunt începătoare. Mă descurc?',
      r:'Da. Amândouă tiparele sunt de nivel Începător+: tehnici de bază, plus câteva lucruri noi pe care le luăm pas cu pas în grup. Tehnicile sunt scrise la fiecare tipar mai sus.' },
    { i:'Cum știu ce mărime să aleg dacă nu văd tiparul?',
      r:'În calculator ai, la fiecare tipar, bustul finit pe fiecare mărime, tensiunea și mărimea de andrele. Alegi mărimea acolo și tot acolo vezi estimarea de gheme.' },
    { i:'Pot folosi firul meu?',
      r:'Da. Tiparul îl cumperi separat, iar dacă iei și firele ediției vine tipărit în același colet cu ele.' },
    { i:'Ce fac dacă rămân în urmă?',
      r:'Nimic. Etapele sunt un ritm sugerat, nu un termen. Grupul rămâne deschis și după ce se termină.' },
    { i:'Pot returna firele?',
      r:'Da, ai 14 zile de la primire, ca la orice comandă. Ghemele trebuie să fie nedesfăcute.' },
  ],
};

/* ── FIRELE EDIŢIEI ──────────────────────────────────────────────────────────
   ⚠️ CANTITATEA SE CALCULEAZĂ DIN TENSIUNE, nu din metraj. Densitatea liniară
   (grame pe metru) e un proxy înşelător pentru grosime: Atlas are 2,16 m/g,
   deci e mai subţire pe gram decât Peer Gynt cu 1,82, şi totuşi se tricotează
   MAI LEJER, 18 ochiuri faţă de 20, fiindcă e filat cardat şi are volum. Pe
   formula veche, calculatorul dădea încrezător un număr greşit la Atlas, la
   Gilliatt şi la mohair. Acelaşi lucru s-a descoperit şi la calculatorul de
   metraj, la auditul din august.

   `tensiune` = ochiuri pe 10 cm de pe eticheta producătorului. Pentru firul pe
   care e SCRIS tiparul, tensiunea efectivă e cea a tiparului, prin definiţie.

   `componente` = fire ţinute împreună. Ai nevoie de aceeaşi LUNGIME din fiecare.

   ⭐ PREŢURILE NU SE SCRIU AICI. Vin pe nuanţă din Shopify, prin `culori.js`.
   Momentan sunt 5 lei pe tot, o cifră de TEST pusă ca să se poată vedea fluxul.
   Cât timp un preţ e 0, calculatorul scrie „preţ de stabilit", nu „0,00 lei".

   m = metri/ghem · g = grame/ghem                                             */
const YARNS = [
  {
    /* Specificaţii de pe sandnes-garn.com/peer-gynt-1865 și din fargekart-ul
       oficial (toamna '25). ⚠️ Eticheta Sandnes dă 22 ochiuri / 10 cm, dar
       PetiteKnit scrie ambele tipare pe Peer Gynt la 20. Firul de referinţă
       foloseşte tensiunea TIPARULUI, 20; `tensiuneEticheta` e păstrată fiindcă
       de ea atârnă comparaţia cu celelalte fire, vezi nota de la Atlas. */
    id: 'kal-peer-gynt', handle: 'kal-01-peer-gynt',
    descriere: 'Pe piață din 1938 și de atunci firul de referință pentru puloverele norvegiene tradiționale. Lână norvegiană netratată superwash: haina iese ușoară și caldă, se înmoaie cu fiecare purtare, nu face scame și își ține forma ani la rând. Firul pe care sunt scrise ambele tipare ale ediției.',
    brand: 'Sandnes Garn', nume: 'Peer Gynt',
    m: 91, g: 50, ac: '3,5 – 4 mm', tensiune: 20, tensiuneEticheta: 22,
    compozitie: '100% lână norvegiană',
    compozitieTweed: '75% lână norvegiană, 25% tweed de lână din Peru',
    origine: 'Norvegia', pungaFurnizor: 20,
  },
  {
    /* Linia co-branded Sandnes × PetiteKnit: aceeaşi bază de fir, altă carte de
       culori, care nu are NICIUN cod comun cu paleta obişnuită. Tiparele ediţiei
       sunt PetiteKnit, deci ăsta e firul cel mai firesc pentru KAL. */
    id: 'kal-petiteknit-peer-gynt', handle: 'kal-01-petiteknit-peer-gynt',
    descriere: 'Același fir Peer Gynt, cu altă carte de culori. Nuanțele sunt altele decât ale gamei obișnuite, niciun cod nu se repetă între cele două palete. Dacă vrei puloverul exact în tonul din fotografiile tiparului, de aici îl alegi.',
    brand: 'Sandnes Garn', nume: 'PetiteKnit Peer Gynt',
    m: 91, g: 50, ac: '3,5 – 4 mm', tensiune: 20, tensiuneEticheta: 22,
    compozitie: '100% lână norvegiană',
    origine: 'Norvegia', pungaFurnizor: 20,
  },
  {
    /* Sandnes îl dă la 20-21 de ochiuri pe 10 cm, deci firul cade FIX pe tensiunea
       celor două tipare şi cantitatea rămâne cea din tipar. E singurul fir al ediţiei,
       în afară de Peer Gynt însuşi, la care calculatorul nu ajustează nimic. */
    id: 'kal-double-sunday', handle: 'kal-01-double-sunday', brand: 'Sandnes Garn', nume: 'Double Sunday',
    descriere: 'Cel mai gros fir din familia Sunday, un merinos netratat superwash care se tricotează la 20 până la 21 de ochiuri pe 10 cm, adică chiar tensiunea tiparelor din ediție. Fiindcă nu e superwash, fibra își păstrează elasticitatea, iar tricotul se așază frumos la blocare. Cantitatea de fire este exact cea din tipar.',
    m: 108, g: 50, ac: '3,5 – 4 mm', tensiune: 20, tensiuneEticheta: 21,
    compozitie: '100% lână merinos',
    pungaFurnizor: 20,
  },
  {
    /* Aceeaşi bază ca Double Sunday, cu cartea de culori PetiteKnit: 16 nuanţe, niciun
       cod comun cu paleta obişnuită. Fizica e identică, deci calculatorul nu ajustează
       nimic nici aici, cantitatea rămâne cea din tipar. */
    id: 'kal-petiteknit-double-sunday', handle: 'kal-01-petiteknit-double-sunday',
    brand: 'Sandnes Garn', nume: 'PetiteKnit Double Sunday',
    descriere: 'Același fir Double Sunday, cu cartea de culori PetiteKnit. Nuanțele vin din colaborarea Sandnes cu PetiteKnit și sunt altele decât ale gamei obișnuite. Se tricotează la 20 până la 21 de ochiuri pe 10 cm, adică fix tensiunea tiparelor, deci cantitatea de fire este exact cea din tipar.',
    m: 108, g: 50, ac: '3,5 – 4 mm', tensiune: 20, tensiuneEticheta: 21,
    compozitie: '100% lână merinos',
    pungaFurnizor: 20,
  },
  {
    id: 'kal-sayama', handle: 'kal-01-sayama', brand: 'Pascuali', nume: 'Sayama',
    descriere: 'Numit după Sajama, cel mai înalt vârf al Boliviei, și filat din lână de lamă cu lână de munte. Amestecul ține echilibrul între ușurință și rezistență, iar Pascuali l-a gândit anume pentru tricotul scandinav și pentru modelele în mai multe culori. Paleta merge de la albul lamei până la negru profund.',
    m: 112, g: 50, ac: '4 mm', tensiune: 20, tensiuneEticheta: 20,
    compozitie: '50% lână virgină, 50% lână de lamă',
  },
  {
    /* Ţinute împreună. Cantităţile ies din acelaşi calcul, iar rezultatul se
       verifică independent: tiparul Chestnut dă, pentru varianta lui cu două
       fire, 300-500 g Pelsuld şi 150-250 g Silk Mohair pe toată plaja de mărimi
       (150-175 g e DOAR mărimea XS). Modelul nostru cade în intervalele
       tiparului pe toate cele 9 mărimi, verificat în metri la auditul din 17.08.
       Fiecare componentă e propriul produs în Shopify, deci propriul `handle`. */
    id: 'kal-majo-duo', brand: 'Majo Garn', nume: 'Fine Merino + Pearl Mohair',
    descriere: 'Două fire ținute împreună. Fine Merino dă structura: merinos italian fin, elastic, cu ochiuri clar desenate și deloc iritant. Pearl Mohair, 70% super kid mohair cu 30% mătase Mulberry, adaugă volum, căldură și haloul acela fin care se vede în lumină. Împreună, cea mai luxoasă alegere a ediției.',
    ac: '4 mm', tensiune: 20,
    compozitie: 'merinos italian ținut cu super kid mohair și mătase',
    componente: [
      { nume: 'Fine Merino',  handle: 'kal-01-fine-merino',  m: 175, g: 50 },
      { nume: 'Pearl Mohair', handle: 'kal-01-pearl-mohair', m: 210, g: 25 },
    ],
  },
  {
    /* ⚠️ Datele de pe etichetă nu se leagă între ele: 120 m la 25 g sunt 480 m
       la 100 g, faţă de 182 la Peer Gynt, deci firul e de două ori şi jumătate
       mai subţire, şi totuşi Lamana dă aproape aceeaşi tensiune, 22 ochiuri.
       Cel mai probabil tensiunea aceea presupune firul ţinut dublu. Până se
       lămureşte, calculatorul îl marchează, nu dă un număr cu încredere. */
    id: 'kal-como', handle: 'kal-01-como', brand: 'Lamana', nume: 'Como',
    descriere: 'Merinos extrafin certificat OEKO-TEX, într-un fir subțire, de 120 m la ghemul de 25 g. E cel mai fin fir al ediției și cel care cere cea mai multă răbdare, dar dă un tricot suplu, cu cădere frumoasă. Lamana dă pentru un pulover mărimea M în jur de 275 g.',
    m: 120, g: 25, ac: '3,5 – 4,5 mm', tensiune: 22, tensiuneEticheta: 22,
    compozitie: '100% lână merinos extrafină',
    incert: 'Eticheta dă 22 ochiuri, dar firul e de 2,5 ori mai subțire decât cel din tipar. Verifică cu o mostră înainte să comanzi.',
  },
];

/* Culorile se scriu compact ca [nume, hex]; aici primesc structura completă.
   În Liquid, `variantId` vine din variantă, iar `img` din imaginea variantei. */
/* Normalizez fiecare fir la o listă de LINII: un fir simplu are o linie, unul
   ţinut dublu are două. Aşa amândouă trec prin exact acelaşi cod la calcul, la
   afişare şi la adăugarea în coş, în loc să ramific în cinci locuri. */
YARNS.forEach(y => {
  const comps = y.componente || [{ nume: y.nume, handle: y.handle, m: y.m, g: y.g }];
  y.linii = comps.map(c => {
    /* Culorile NU se mai scriu de mână: vin din `culori.js`, generat din produsele
       de Shopify, cheia fiind handle-ul produsului. Aici doar le leg de linie. */
    const culori = (typeof CULORI !== 'undefined' && CULORI[c.handle]) || [];
    if (!culori.length) console.warn('KAL: fără culori pentru', c.handle,
      '— rulează `python3 _din-shopify.py`');
    return Object.assign({}, c, { culori, culoriToate: culori });
  });
  y.tinutDublu = y.linii.length > 1;
  y.culoriTotalFurnizor = y.linii.reduce((t, l) => t + l.culoriToate.length, 0);
  y.culoriAfisate = y.linii.reduce((t, l) => t + l.culori.length, 0);
  /* Preţul e pe NUANŢĂ, aşa cum e în Shopify. Pe card apare intervalul dacă diferă,
     iar preţul unei linii e cel al nuanţei alese, nu o medie. */
  const pret = (l, f) => l.culori.length ? f(...l.culori.map(c => c.price)) : 0;
  y.pretCard    = y.linii.reduce((t, l) => t + pret(l, Math.min), 0);
  y.pretCardMax = y.linii.reduce((t, l) => t + pret(l, Math.max), 0);
});

/* ── TIPARELE ────────────────────────────────────────────────────────────────
   refYarnId = firul pe care e scris tiparul. Din el vine metrajul de bază.
   skeins    = gheme din firul de referință, pe fiecare mărime, în ordinea `sizes`.
   Omul NU vede tiparul înainte să cumpere, deci tot ce ar fi citit din el ca să
   aleagă mărimea trebuie să fie aici.                                          */
const PATTERNS = [
  {
    /* Chestnut Sweater · PetiteKnit. Specificaţii luate de pe petiteknit.com,
       nu de la revânzători. Tiparul se cumpără TIPĂRIT de la PetiteKnit şi se
       dă gratuit în colet: dăm un produs cumpărat, nu reproducem PDF-ul lor. */
    id: 'kal-chestnut-sweater', handle: 'kal-01-tipar-chestnut',
    brand: 'PetiteKnit',
    nume: 'Chestnut Sweater',
    subtitlu: 'Pulover supradimensionat, tricotat de sus în jos',
    refYarnId: 'kal-peer-gynt',
    tensiune: 20, ac: '4 mm',                 // 20 ochiuri x 28 rânduri / 10 cm, după spălare
    /* Nivelul oficial PetiteKnit, confirmat de Vlad pe 19.08 pentru ambele tipare.
       „Mediu"/„Avansat" fuseseră estimările noastre pe scara Sandnes din catalog. */
    dificultate: 'Începător+',
    /* Lejeritatea din tipar: cu cât bustul finit e mai larg decât corpul. Explică de
       ce busturile din tabel par uriaşe, un M de 125 cm e pe un corp de ~95. */
    ease: '30 cm',
    tehnici: 'Rânduri scurte, de sus în jos, ochiuri ridicate, tricotat circular',
    sizes: [
      { l:'XS',  bust:'bust finit 115 cm' }, { l:'S',   bust:'bust finit 120 cm' },
      { l:'M',   bust:'bust finit 125 cm' }, { l:'L',   bust:'bust finit 130 cm' },
      { l:'XL',  bust:'bust finit 140 cm' }, { l:'2XL', bust:'bust finit 150 cm' },
      { l:'3XL', bust:'bust finit 160 cm' }, { l:'4XL', bust:'bust finit 170 cm' },
      { l:'5XL', bust:'bust finit 180 cm' },
    ],
    /* 650 (700) 750 (800) 900 (950) 1000 (1050) 1100 g Peer Gynt, la 50 g ghemul */
    skeins: [13, 14, 15, 16, 18, 19, 20, 21, 22],
  },
  {
    /* Eva Cardigan · PetiteKnit */
    id: 'kal-eva-cardigan', handle: 'kal-01-tipar-eva',
    brand: 'PetiteKnit',
    nume: 'Eva Cardigan',
    subtitlu: 'Cardigan cu răscroială în V și bordură lată în 2×2',
    refYarnId: 'kal-peer-gynt',
    tensiune: 20, ac: '4 mm',                 // 20 ochiuri x 30 rânduri / 10 cm
    dificultate: 'Începător+',
    ease: '26 cm',
    tehnici: 'Platcă separată la spate, de sus în jos, mâneci circulare, bordură ridicată',
    sizes: [
      { l:'XXS', bust:'bust finit 106 cm' }, { l:'XS',  bust:'bust finit 112 cm' },
      { l:'S',   bust:'bust finit 116 cm' }, { l:'M',   bust:'bust finit 120 cm' },
      { l:'L',   bust:'bust finit 126 cm' }, { l:'XL',  bust:'bust finit 132 cm' },
      { l:'2XL', bust:'bust finit 134 cm' }, { l:'3XL', bust:'bust finit 140 cm' },
      { l:'4XL', bust:'bust finit 150 cm' }, { l:'5XL', bust:'bust finit 156 cm' },
    ],
    /* 550-600 (600) 600 (650) 650 (700) 750 (800) 850 (900) g Peer Gynt.
       ⚠️ La XXS tiparul dă un INTERVAL, 550-600 g. Am luat marginea de sus:
       la o precomandă, prea puţin fir e mult mai rău decât un ghem în plus. */
    skeins: [12, 12, 12, 13, 13, 14, 15, 16, 17, 18],
  },
];

/* Tiparele îşi iau fotografiile şi variant id-ul din `culori.js`, prin `handle`.
   Aceeaşi logică ca la fire: produsul din Shopify e sursa, fişierul ăsta ţine
   doar ce nu încape pe produs (tabelul de metraj, mărimile, tehnicile). */
PATTERNS.forEach(p => {
  const t = (typeof TIPARE !== 'undefined' && TIPARE[p.handle]) || null;
  if (!t) console.warn('KAL: fără produs de tipar pentru', p.handle,
    '— rulează `python3 _din-shopify.py`');
  p.poze = (t && t.poze) || [];
  p.img = p.poze.length ? p.poze[0].img : null;
  p.patternVariantId = (t && t.variantId) || null;
  /* ⚠️ Preţul tiparului vine din produs, nu e scris aici: pe 31.08.2026 a trecut de la
     0 la 53 lei, cât costă şi tiparele publice, iar panoul din calculator îl adună la
     total. Cât timp era 0, linia lui scria „Gratuit" şi stătea în afara sumei; dacă
     preţul se schimbă din nou, se schimbă singur şi în calculator, prin `_din-shopify.py`. */
  p.patternPrice = (t && t.price != null) ? t.price : 0;
});
